export const translations = {
  el: {
    nav: {
      home: "Αρχική",
      about: "Σχετικά",
      services: "Υπηρεσίες",
      nagayu: "Nagayu",
      selfwash: "Self Service",
      grooming: "Grooming",
      gallery: "Ο Χώρος",
      contact: "Επικοινωνία",
      book: "Κλείσε Ραντεβού",
      my_bookings: "Τα Ραντεβού μου",
      boutique: "Boutique",
      my_account: "Ο λογαριασμός μου",
    },
    hero: {
      badge: "Self-Wash Lounge & Pet Spa Boutique",
      title_1: "Η φροντίδα που αξίζει",
      title_2: "στον καλύτερό σου φίλο",
      subtitle:
        "Στο Κερατσίνι δημιουργήσαμε έναν όμορφο, φιλόξενο χώρο αφιερωμένο στην υγιεινή, την άνεση και την ευεξία των κατοικιδίων. Επαγγελματικό grooming, self-service μπάνιο και η αποκλειστική θεραπεία Nagayu CO₂.",
      cta_primary: "Κλείσε Ραντεβού",
      cta_secondary: "Ανακάλυψε το Nagayu",
      stat_1: "Πιστοποιημένα προϊόντα",
      stat_2: "Επαγγελματικός εξοπλισμός",
      stat_3: "Φιλικός χώρος για τα ζώα",
    },
    about: {
      tag: "Σχετικά με εμάς",
      title: "Ένας χώρος φτιαγμένος με αγάπη",
      p1: "Στο Care For Me πιστεύουμε ότι η φροντίδα ενός κατοικιδίου πρέπει να είναι μια ευχάριστη εμπειρία. Γι' αυτό δημιουργήσαμε έναν χώρο όπου μπορείτε εύκολα και γρήγορα να περιποιηθείτε τον σκύλο σας μόνοι σας, με επαγγελματικές εγκαταστάσεις.",
      p2: "Κάθε λεπτομέρεια έχει σχεδιαστεί ώστε η διαδικασία του πλυσίματος να είναι άνετη τόσο για τα ζώα όσο και για τους κηδεμόνες τους — σε ένα περιβάλλον ασφαλές, καθαρό και ζεστό.",
      why_title: "Γιατί Self Service;",
      why_text:
        "Το self service πλύσιμο σάς δίνει την ευκαιρία να αφιερώσετε χρόνο στο κατοικίδιό σας και να ενισχύσετε τον δεσμό σας. Πολλά ζώα νιώθουν πιο ήρεμα όταν τα φροντίζει ο άνθρωπός τους.",
      features: [
        { t: "Ειδικές μπανιέρες", d: "Σχεδιασμένες στο σωστό ύψος για άνεση." },
        { t: "Επαγγελματικά ντους", d: "Σταθερή πίεση & θερμοκρασία." },
        { t: "Πιστοποιημένα προϊόντα", d: "Ασφαλή για κάθε τύπο τριχώματος." },
        { t: "Ισχυρά στεγνωτήρια", d: "Γρήγορο & απαλό στέγνωμα." },
      ],
    },
    services: {
      tag: "Οι υπηρεσίες μας",
      title: "Τρεις τρόποι να περιποιηθείς το κατοικίδιό σου",
      grooming_title: "Επαγγελματικό Grooming",
      grooming_desc:
        "Ολοκληρωμένη περιποίηση από εμάς: μπάνιο, κούρεμα, νύχια, αυτιά και styling. Συμπλήρωσε τη φόρμα και κλείσε αμέσως το ραντεβού σου online — η κράτηση επιβεβαιώνεται αυτόματα.",
      grooming_cta: "Ζήτησε ραντεβού",
      selfwash_title: "Self-Service Wash",
      selfwash_desc:
        "Πλύνε τον σκύλο σου μόνος σου με επαγγελματικό εξοπλισμό. Διάλεξε πλάνο ανάλογα με το μέγεθος και κλείσε online.",
      selfwash_cta: "Δες τα πλάνα",
      nagayu_title: "Nagayu CO₂ Spa",
      nagayu_desc:
        "Η αποκλειστική ιαπωνική θεραπεία υδροθεραπείας με διοξείδιο του άνθρακα. Βαθύς καθαρισμός, ανακούφιση δέρματος και μεταξένιο τρίχωμα.",
      nagayu_cta: "Μάθε περισσότερα",
    },
    nagayu: {
      tag: "Signature Θεραπεία",
      title: "Nagayu CO₂ Spa",
      subtitle:
        "Η ιαπωνική θεραπεία υδροθεραπείας που αλλάζει τα δεδομένα. Μια κάψουλα CO₂ τοποθετείται στο τηλέφωνο της μπανιέρας και δημιουργεί ανθρακούχο νερό γεμάτο ευεργετικές ιδιότητες.",
      how_title: "Πώς λειτουργεί",
      how_text:
        "Μετά το σαμπουάν, τοποθετούμε μια ταμπλέτα CO₂ στο ειδικό ντους. Διαλύεται στιγμιαία και δημιουργεί ανθρακούχο ξέβγαλμα ~3 λεπτών, που καθαρίζει σε βάθος όσο το απλό νερό δεν μπορεί.",
      benefits: [
        { t: "Βαθύς καθαρισμός πόρων", d: "Απομακρύνει ρύπους & υπολείμματα που προκαλούν οσμές." },
        { t: "Ανακούφιση δέρματος", d: "Καταπραΰνει κνησμό, δερματίτιδα & ερεθισμούς." },
        { t: "Μεταξένιο τρίχωμα", d: "Πλούσιο, λαμπερό & υγιές τρίχωμα." },
        { t: "Καλύτερη κυκλοφορία", d: "Το CO₂ ενισχύει τη ροή αίματος & την αναγέννηση." },
        { t: "Διαρκής φρεσκάδα", d: "Το κατοικίδιο μυρίζει καθαρό για περισσότερο." },
        { t: "100% φυσικό", d: "Μη επεμβατικό, ασφαλές & φιλικό στα ζώα." },
      ],
      note: "Η θεραπεία Nagayu ανακουφίζει τα συμπτώματα αλλά δεν αντικαθιστά την κτηνιατρική φροντίδα.",
      cta: "Κλείσε με Nagayu",
    },
    gallery: {
      tag: "Ο χώρος μας",
      title: "Μια ματιά στον χώρο μας",
      subtitle: "Ρίξε μια ματιά στον χώρο μας και σε μερικούς από τους τετράποδους φίλους που περιποιηθήκαμε με αγάπη.",
      show_more: "Περισσότερες φωτογραφίες",
      show_less: "Λιγότερες φωτογραφίες",
    },
    hours: {
      title: "Ωράριο Λειτουργίας",
      closed: "Κλειστά",
      days: [
        { d: "Δευτέρα", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Τρίτη", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Τετάρτη", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Πέμπτη", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Παρασκευή", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Σάββατο", h: "11:00–15:00" },
        { d: "Κυριακή", h: "Κλειστά", closed: true },
      ],
    },
    lg: {
      back: "Αρχική σελίδα",
      badge: "Επαγγελματικό Grooming",
      hero_h1: "Επαγγελματικό Grooming Σκύλων",
      hero_p: "Χαρίστε στον σκύλο σας μια ολοκληρωμένη περιποίηση από έμπειρα χέρια. Το επαγγελματικό grooming διατηρεί το τρίχωμα υγιές, το δέρμα καθαρό και το κατοικίδιό σας άνετο — ιδανικό για κάθε ράτσα και ηλικία.",
      cta_book: "Κλείστε Ραντεβού",
      cta_request: "Ζητήστε Ραντεβού",
      includes_h2: "Τι περιλαμβάνει το Grooming",
      includes: ["Μπάνιο", "Στέγνωμα", "Κούρεμα", "Ξεμπέρδεμα", "Περιποίηση νυχιών", "Καθαρισμός αυτιών", "Nagayu CO₂ Spa (+10€)", "Συμβουλές φροντίδας"],
      why_h2: "Γιατί να επιλέξετε το Care For Me",
      why: ["Έμπειρο προσωπικό", "Ασφαλής χειρισμός", "Ποιοτικά προϊόντα", "Καθαρός & υγιεινός χώρος", "Εξατομικευμένη φροντίδα"],
      space_h2: "Ο Χώρος μας",
      space_p: "Ένας όμορφος, φιλόξενος και καθαρός χώρος σχεδιασμένος για την άνεση και την ασφάλεια του κατοικιδίου σας.",
      contact_h2: "Ελάτε να γνωριστούμε",
    },
    ls: {
      back: "Αρχική σελίδα",
      badge: "Self-Service Wash",
      hero_h1: "Self Wash – Πλύνετε μόνοι σας τον σκύλο σας εύκολα & καθαρά",
      hero_p: "Ξεχάστε την ακαταστασία και το άγχος του μπάνιου στο σπίτι. Στο Care For Me βρίσκετε επαγγελματικές μπανιέρες, ζεστό νερό και όλα τα προϊόντα, ώστε να περιποιηθείτε τον σκύλο σας γρήγορα, εύκολα και οικονομικά.",
      cta_book: "Κλείστε Ραντεβού",
      cta_request: "Ζητήστε Ραντεβού",
      how_h2: "Πώς λειτουργεί το Self Wash",
      how_steps: [
        { t: "1. Κλείνετε ραντεβού", d: "Διαλέγετε πλάνο ανάλογα με το μέγεθος του σκύλου σας και ώρα που σας βολεύει." },
        { t: "2. Έρχεστε στον χώρο", d: "Σας υποδεχόμαστε και σας δείχνουμε τον σταθμό πλυσίματος και τον εξοπλισμό." },
        { t: "3. Πλένετε άνετα", d: "Χρησιμοποιείτε τις ειδικές μπανιέρες, τα ντους και τα προϊόντα μας με άνεση." },
        { t: "4. Στεγνώνετε & φεύγετε", d: "Στεγνώνετε τον σκύλο σας με τα επαγγελματικά στεγνωτήρια — εμείς καθαρίζουμε τον χώρο." },
      ],
      find_h2: "Τι θα βρείτε στον χώρο",
      find: ["Ειδικές μπανιέρες στο σωστό ύψος", "Επαγγελματικά ντους ζεστού/κρύου νερού", "Πιστοποιημένα σαμπουάν & προϊόντα", "Ισχυρά επαγγελματικά στεγνωτήρια", "Πετσέτες & πλήρης εξοπλισμός", "Nagayu CO₂ Spa (+10€)"],
      why_h2: "Γιατί να επιλέξετε το Care For Me",
      why: ["Καθαρός & υγιεινός χώρος", "Επαγγελματικός εξοπλισμός", "Εύκολη & γρήγορη διαδικασία", "Οικονομική λύση", "Χωρίς ακαταστασία στο σπίτι"],
      space_h2: "Ο Χώρος μας",
      space_p: "Ένας καθαρός, φωτεινός και φιλόξενος χώρος, σχεδιασμένος ώστε το πλύσιμο να είναι εύκολο και ευχάριστο για εσάς και τον σκύλο σας.",
      contact_h2: "Ελάτε να γνωριστούμε",
    },
    selfwash: {
      tag: "Self-Service Πλάνα",
      type_label: "Κράτηση Self-Service",
      title: "Διάλεξε το πλάνο σου",
      subtitle: "Τιμές ανάλογα με το μέγεθος του σκύλου σου. Όλα περιλαμβάνουν πλήρη πρόσβαση στον εξοπλισμό μας.",
      badge_instant: "Άμεση επιβεβαίωση",
      badge_secure: "Ασφαλής κράτηση online",
      minutes: "λεπτά",
      book: "Κράτηση online",
      includes: "Περιλαμβάνει μπανιέρα, ντους, προϊόντα & στεγνωτήρα",
      plans: [
        { name: "Μικρόσωμο Σκυλάκι", min: 16, price: 10 },
        { name: "Μεσαίο Σκυλάκι", min: 22, price: 14 },
        { name: "Μεγάλος Σκύλος", min: 32, price: 20 },
        { name: "Γίγαντας", min: 40, price: 24 },
      ],
      popular: "Δημοφιλές",
      choose: "Επίλεξε & Κλείσε",
      booking: {
        title: "Κράτηση Self-Service",
        step_plan: "Πλάνο",
        step_datetime: "Ημ/νία & Ώρα",
        step_details: "Στοιχεία",
        selected_plan: "Επιλεγμένο πλάνο",
        pick_date: "Διάλεξε ημερομηνία",
        pick_time: "Διάθεσιμες ώρες",
        no_slots: "Δεν υπάρχουν διαθέσιμες ώρες. Διάλεξε άλλη ημέρα.",
        call_soon: "Για ραντεβού εντός των επόμενων 2 ωρών, κάλεσέ μας:",
        coupon_label: "Κωδικός κουπονιού (προαιρετικό)",
        coupon_check: "Έλεγχος",
        coupon_applied: "Εφαρμόστηκε έκπτωση {label}",
        coupon_fill_phone: "Συμπλήρωσε πρώτα το τηλέφωνό σου",
        loading: "Φόρτωση...",
        name: "Όνομα",
        surname: "Επώνυμο (προαιρετικό)",
        phone: "Κινητό τηλέφωνο",
        phone_hint: "10 ψηφία, μορφή 69ΧΧΧΧΧΧΧΧ",
        phone_error: "Το τηλέφωνο πρέπει να είναι 10 ψηφία που ξεκινούν με 69",
        email: "Email",
      email_error: "Παρακαλώ βάλε ένα έγκυρο email",
        notes: "Σημειώσεις (προαιρετικό)",
        payment_note: "Η πληρωμή γίνεται στο κατάστημα.",
        back: "Πίσω",
        next: "Συνέχεια",
        confirm: "Επιβεβαίωση κράτησης",
        confirming: "Επιβεβαίωση...",
        success: "Η κράτησή σου επιβεβαιώθηκε! Σε περιμένουμε.",
        error: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
        slot_taken: "Αυτή η ώρα μόλις κλείστηκε. Διάλεξε άλλη.",
        required: "Συμπλήρωσε ονοματεπώνυμο & τηλέφωνο.",
        summary: "Σύνοψη",
        addon_title: "Πρόσθεσε Nagayu CO₂ Spa",
        addon_desc: "Ιαπωνική υδροθεραπεία CO₂ για βαθύ καθαρισμό & γυαλιστερό τρίχωμα.",
        addon_price: "+10€",
        total: "Σύνολο",
      },
    },
    grooming: {
      tag: "Κράτηση Grooming",
      title: "Κλείσε το ραντεβού σου online",
      subtitle: "Επίλεξε ημερομηνία & ώρα και ολοκλήρωσε την κράτηση σου σε λίγα λεπτά — άμεση επιβεβαίωση.",
      badge_instant: "Άμεση επιβεβαίωση",
      badge_secure: "Ασφαλής κράτηση online",
      customer_name: "Όνομα",
      surname: "Επώνυμο (προαιρετικό)",
      phone: "Κινητό τηλέφωνο",
      phone_hint: "10 ψηφία, μορφή 69ΧΧΧΧΧΧΧΧ",
      phone_error: "Το τηλέφωνο πρέπει να είναι 10 ψηφία που ξεκινούν με 69",
      email: "Email",
      email_error: "Παρακαλώ βάλε ένα έγκυρο email",
      pet_name: "Όνομα κατοικιδίου",
      pet_breed: "Ράτσα",
      pet_size: "Μέγεθος",
      service_wanted: "Τι θα θέλατε για τον σκύλο σας;",
      service_wanted_placeholder: "π.χ. μπάνιο & στέγνωμα, κούρεμα με ψαλίδι, νύχια, καθαρισμός αυτιών, Nagayu spa...",
      date: "Ημερομηνία",
      time: "Ώρα",
      notes: "Επιπλέον σημειώσεις (προαιρετικό)",
      pick_date: "Διάλεξε ημερομηνία",
      pick_time: "Διάλεξε ώρα",
      pick_size: "Διάλεξε μέγεθος",
      closed_day: "Κλειστά αυτή την ημέρα",
      loading: "Φόρτωση...",
      time_taken: "κλεισμένη",
      call_more_slots: "Για περισσότερες διαθέσιμες ώρες, καλέστε μας:",
      call_soon: "Για ραντεβού εντός των επόμενων 2 ωρών, κάλεσέ μας:",
      coupon_label: "Κωδικός κουπονιού (προαιρετικό)",
      coupon_check: "Έλεγχος",
      coupon_applied: "Εφαρμόστηκε έκπτωση {label}",
      coupon_fill_phone: "Συμπλήρωσε πρώτα το τηλέφωνό σου",
      sizes: { small: "Μικρόσωμο", medium: "Μεσαίο", large: "Μεγάλο", giant: "Γίγαντας" },
      submit: "Επιβεβαίωση κράτησης",
      submitting: "Επιβεβαίωση...",
      success: "Η κράτησή σου επιβεβαιώθηκε! Σε περιμένουμε.",
      error: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
      required: "Συμπλήρωσε τα υποχρεωτικά πεδία.",
    },
    my_bookings: {
      title: "Τα Ραντεβού μου",
      subtitle: "Δες, τροποποίησε ή ακύρωσε τα ραντεβού σου online",
      phone_label: "Κινητό τηλέφωνο",
      phone_hint: "10 ψηφία, μορφή 69ΧΧΧΧΧΧΧΧ",
      phone_error: "Το τηλέφωνο πρέπει να είναι 10 ψηφία που ξεκινούν με 69",
      search: "Εύρεση Ραντεβού",
      searching: "Αναζήτηση...",
      change_phone: "Άλλο τηλέφωνο",
      no_bookings: "Δεν βρέθηκαν ενεργά ραντεβού για αυτόν τον αριθμό.",
      lookup_error: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
      grooming: "Grooming",
      selfwash: "Self-Service",
      status: "Κατάσταση",
      edit: "Αλλαγή",
      cancel: "Ακύρωση",
      confirm_cancel: "Σίγουρα θέλεις να ακυρώσεις το ραντεβού;",
      cancelled: "Το ραντεβού ακυρώθηκε.",
      cancel_error: "Αποτυχία ακύρωσης.",
      edit_title: "Αλλαγή Ραντεβού",
      date: "Ημερομηνία",
      time: "Ώρα",
      notes: "Σημειώσεις",
      back: "Πίσω",
      save: "Αποθήκευση",
      saving: "Αποθήκευση...",
      saved: "Οι αλλαγές αποθηκεύτηκαν.",
      save_error: "Αποτυχία αποθήκευσης.",
      slot_taken: "Αυτή η ώρα είναι κλεισμένη. Διάλεξε άλλη.",
      invalid_time: "Μη διαθέσιμη ώρα.",
      loading: "Φόρτωση...",
      no_slots: "Δεν υπάρχουν διαθέσιμες ώρες.",
      privacy_note: "Δείχνουμε μόνο ενεργά ραντεβού. Για ιστορικό, καλέστε μας.",
    },
    contact: {
      tag: "Επικοινωνία",
      title: "Έλα να μας γνωρίσεις",
      address_label: "Διεύθυνση",
      address: "Σμολένσκυ 1, Κερατσίνι, 18756",
      get_directions: "Οδηγίες πλοήγησης",
      phone_label: "Τηλέφωνα",
      email_label: "Email",
      hours_label: "Ώρες",
      hours: "Δευτ–Σαβ: 09:00–21:00",
      form_title: "Στείλε μας μήνυμα",
      first_name: "Όνομα",
      last_name: "Επώνυμο",
      email: "Email",
      message: "Μήνυμα",
      send: "Αποστολή",
      sending: "Αποστολή...",
      success: "Ευχαριστούμε πολύ! Θα επικοινωνήσουμε σύντομα μαζί σας.",
      error: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
      follow: "Βρες μας στα Social",
    },
    footer: {
      tagline: "Self-Wash Lounge & Pet Spa Boutique στο Κερατσίνι.",
      quick: "Γρήγοροι σύνδεσμοι",
      contact: "Επικοινωνία",
      rights: "Με επιφύλαξη παντός δικαιώματος.",
      admin: "Διαχείριση",
    },
    seo: {
      home_title: "Care For Me | Pet Spa & Self-Service Dog Wash — Κερατσίνι",
      home_desc: "Επαγγελματικό grooming, self-service μπάνιο για σκύλους, θεραπεία Nagayu CO₂ και boutique προϊόντων στο Κερατσίνι. Κλείστε ραντεβού online.",
      grooming_title: "Grooming για σκύλους στο Κερατσίνι | Care For Me",
      grooming_desc: "Επαγγελματικό grooming: λούσιμο, κούρεμα και περιποίηση από έμπειρη groomer. Δείτε πακέτα και κλείστε ραντεβού online.",
      self_title: "Self-Service μπάνιο για σκύλους | Care For Me Κερατσίνι",
      self_desc: "Πλύντε τον σκύλο σας σε σύγχρονο self-service χώρο με επαγγελματικό εξοπλισμό και θεραπεία Nagayu CO₂. Κλείστε θέση online.",
      shop_title: "Boutique προϊόντων περιποίησης | Care For Me",
      shop_desc: "Προϊόντα περιποίησης και ευεξίας για κατοικίδια. Παραγγείλετε online και παραλάβετε από το κατάστημα στο Κερατσίνι.",
      cart_title: "Καλάθι | Care For Me Boutique",
      checkout_title: "Ολοκλήρωση παραγγελίας | Care For Me Boutique",
      account_title: "Ο λογαριασμός μου | Care For Me",
    },
    reviews: {
      tag: "Κριτικές",
      title: "Τι λένε οι πελάτες μας",
      sub: "Αληθινές εμπειρίες από τη δουλειά μας καθημερινά",
      google_cta: "Βαθμολογήστε μας στο Google",
    },
    share: {
      button: "Κοινοποίηση",
      title: "Κοινοποίηση προϊόντος",
      whatsapp: "WhatsApp",
      viber: "Viber",
      facebook: "Facebook",
      instagram: "Instagram / Story",
      copy: "Αντιγραφή συνδέσμου",
      copied: "Ο σύνδεσμος αντιγράφηκε",
    },
    mapp: {
      splash_tag: "Διαχείριση καταστήματος",
      code_title: "Εισάγετε τον κωδικό σας",
      code_sub: "Ο προσωπικός σας κωδικός πρόσβασης",
      code_wrong: "Λάθος κωδικός — δοκιμάστε ξανά",
      login_btn: "Είσοδος",
      welcome: "Καλωσήρθες",
      pin_setup_title: "Γρήγορη είσοδος με PIN",
      pin_setup_sub: "Όρισε ένα 4ψήφιο PIN για να μη γράφεις τον κωδικό κάθε φορά",
      pin_choose: "Διάλεξε PIN (4 ψηφία)",
      pin_confirm: "Επιβεβαίωσε το PIN",
      pin_mismatch: "Τα PIN δεν ταιριάζουν — ξαναδοκίμασε",
      pin_skip: "Όχι τώρα",
      pin_title: "Εισάγετε PIN",
      pin_wrong: "Λάθος PIN",
      pin_forgot: "Ξέχασα το PIN — είσοδος με κωδικό",
      deactivated_title: "Λογαριασμός απενεργοποιημένος",
      deactivated_msg: "Ο λογαριασμός σας είναι απενεργοποιημένος προσωρινά.",
      deactivated_contact: "Επικοινωνήστε με τον διαχειριστή:",
      deactivated_back: "Πίσω στην είσοδο",
      pin_lockdown: "2 λανθασμένα PIN — ο λογαριασμός απενεργοποιήθηκε αυτόματα για λόγους ασφαλείας",
      bio_offer_title: "Ξεκλείδωμα με δακτυλικό / πρόσωπο;",
      bio_offer_sub: "Χρησιμοποίησε τα βιομετρικά της συσκευής σου για άμεση είσοδο",
      bio_enable: "Ενεργοποίηση",
      bio_later: "Αργότερα",
      bio_unlock: "Ξεκλείδωμα με βιομετρικά",
      tab_today: "Σήμερα",
      tab_new: "Νέο",
      tab_customers: "Πελάτες",
      tab_orders: "Παραγγελίες",
      tab_messages: "Μηνύματα",
      tab_settings: "Ρυθμίσεις",
      tab_dev: "Διαχείριση",
      dev_hub_sub: "Όλες οι λειτουργίες του Dev, μέσα στην εφαρμογή",
      sec_overview: "Επισκόπηση",
      sec_grooming: "Ραντεβού Grooming",
      sec_selfwash: "Self-Service",
      sec_boutique: "Boutique",
      sec_reviews: "Κριτικές",
      sec_gallery: "Gallery",
      sec_appusers: "Χρήστες εφαρμογής",
      sec_sms: "SMS",
      sec_templates: "Templates",
      sec_announcement: "Ανακοίνωση",
      sec_popup: "Popup σελίδας",
      sec_themes: "Θέματα",
      sec_settings: "Ρυθμίσεις",
      sec_system: "Σύστημα",
      stat_today: "Σημερινά",
      stat_pending: "Εκκρεμή",
      stat_orders: "Νέες παραγγελίες",
      stat_msgs: "Αδιάβαστα",
      stat_revenue: "Έσοδα boutique",
      dev_save: "Αποθήκευση",
      dev_saved: "Αποθηκεύτηκε",
      dev_delete: "Διαγραφή",
      dev_del_confirm: "Να διαγραφεί οριστικά;",
      dev_empty: "Τίποτα εδώ ακόμα",
      dev_active: "Ενεργό",
      dev_upload: "Ανέβασμα εικόνας",
      dev_uploading: "Ανέβασμα…",
      dev_price: "Τιμή €",
      dev_sale: "Προσφορά €",
      dev_splash: "Splash screen",
      dev_balance: "Υπόλοιπο SMS",
      dev_test_sms: "Δοκιμαστικό SMS (τηλέφωνο)",
      dev_test_send: "Αποστολή",
      dev_hours: "Ωράριο λειτουργίας",
      dev_closed: "Κλειστά",
      dev_plan_prices: "Τιμές πλάνων self-service",
      dev_health_ok: "Όλα λειτουργούν",
      dev_health_issue: "Χρειάζεται προσοχή",
      dev_open_app: "Άνοιγμα",
      pe_new: "Νέο προϊόν",
      pe_edit: "Επεξεργασία προϊόντος",
      pe_basics: "Βασικά",
      pe_name_gr: "Όνομα (GR)",
      pe_name_en: "Όνομα (EN)",
      pe_desc: "Περιγραφή (GR)",
      pe_price: "Τιμή €",
      pe_category: "Κατηγορία",
      pe_brand: "Συνεργάτης / brand",
      pe_active: "Ενεργό στη boutique",
      pe_orderable: "Online παραγγελία",
      pe_axes: "Άξονες παραλλαγών",
      pe_sizes: "Μεγέθη (με κόμμα)",
      pe_colors: "Χρώματα",
      pe_custom_axis: "Custom άξονας (όνομα GR)",
      pe_custom_opts: "Επιλογές custom (με κόμμα)",
      pe_variants: "Παραλλαγές",
      pe_add_variant: "Νέα παραλλαγή",
      pe_stock: "Stock",
      pe_avail: "Διαθεσιμότητα",
      pe_price_opt: "Τιμή (κενό = βασική)",
      pe_sale_opt: "Προσφορά €",
      pe_photos: "Φωτογραφίες",
      pe_add_photos: "Προσθήκη φωτογραφιών",
      pe_save_first: "Αποθήκευσε πρώτα το προϊόν για φωτογραφίες",
      pe_delete_confirm: "Να διαγραφεί οριστικά το προϊόν;",
      avail_in: "Διαθέσιμο",
      avail_order: "Κατόπιν παραγγελίας",
      avail_out: "Μη διαθέσιμο",
      comma_hint: "π.χ. S, M, L",
      today_empty: "Κανένα ραντεβού",
      upcoming: "Επόμενα",
      today_label: "Σήμερα",
      mark_done: "Ολοκλήρωση",
      mark_cancel: "Ακύρωση",
      cancel_confirm: "Σίγουρα ακύρωση του ραντεβού;",
      status_done_toast: "Το ραντεβού ολοκληρώθηκε",
      status_cancelled_toast: "Το ραντεβού ακυρώθηκε",
      w_choose_type: "Τι ραντεβού κλείνουμε;",
      w_grooming: "Grooming",
      w_grooming_sub: "Λούσιμο, κούρεμα, περιποίηση",
      w_selfwash: "Self-Service",
      w_selfwash_sub: "Ο πελάτης πλένει μόνος του",
      w_customer: "Ποιος πελάτης;",
      w_existing: "Υπάρχων",
      w_new: "Νέος πελάτης",
      w_search_ph: "Όνομα, τηλέφωνο ή κατοικίδιο…",
      w_no_results: "Δεν βρέθηκε — συνέχισε ως νέος",
      w_name: "Ονοματεπώνυμο",
      w_phone: "Κινητό (69…)",
      w_email: "Email (προαιρετικό)",
      w_pet_step: "Στοιχεία κατοικιδίου",
      w_pet_name: "Όνομα κατοικιδίου",
      w_pet_breed: "Ράτσα",
      w_pet_size: "Μέγεθος",
      w_plan_step: "Διάλεξε πλάνο",
      w_nagayu: "Προσθήκη Nagayu CO₂ (+€10)",
      w_date_step: "Ποια ημέρα;",
      w_time_step: "Ποια ώρα;",
      w_any_time: "Οποια ώρα θέλεις — χωρίς περιορισμό διαθεσιμότητας",
      w_no_slots: "Καμία διαθέσιμη ώρα αυτή την ημέρα",
      w_notes: "Σημειώσεις (προαιρετικό)",
      w_confirm: "Επιβεβαίωση",
      w_confirm_btn: "Κλείσιμο ραντεβού",
      w_back: "Πίσω",
      w_next: "Συνέχεια",
      w_success: "Το ραντεβού κλείστηκε!",
      w_success_sub: "Ταξινόμηση: Ναι!",
      w_view_today: "Δες το πρόγραμμα",
      size_small: "Μικρό",
      size_medium: "Μεσαίο",
      size_large: "Μεγάλο",
      size_giant: "Γίγαντας",
      cust_search_title: "Αναζήτηση πελατών",
      cust_bookings: "Ραντεβού",
      cust_revenue: "Έσοδα",
      cust_last: "Τελευταία επίσκεψη",
      cust_history: "Ιστορικό",
      cust_notes: "Σημειώσεις",
      cust_note_ph: "Νέα σημείωση…",
      cust_note_add: "Προσθήκη",
      cust_empty: "Γράψε τουλάχιστον 2 χαρακτήρες",
      orders_empty: "Καμία παραγγελία ακόμα",
      messages_empty: "Κανένα μήνυμα",
      msg_unread: "Νέο",
      settings_title: "Ρυθμίσεις εφαρμογής",
      set_user: "Συνδεδεμένος χρήστης",
      set_change_pin: "Αλλαγή PIN",
      set_current_pin: "Τρέχον PIN",
      set_new_pin: "Νέο PIN",
      set_pin_changed: "Το PIN άλλαξε",
      set_pin_wrong_current: "Λάθος τρέχον PIN",
      set_notif: "Ειδοποιήσεις",
      set_notif_sub: "Νέα ραντεβού & παραγγελίες σε αυτή τη συσκευή",
      set_notif_enable: "Ενεργοποίηση ειδοποιήσεων",
      set_notif_on: "Ενεργές σε αυτή τη συσκευή",
      set_notif_test: "Δοκιμαστική ειδοποίηση",
      set_notif_no_perm: "Δεν έχεις δικαίωμα ειδοποιήσεων — ζήτησέ το από τον διαχειριστή",
      set_notif_denied: "Ο browser απέρριψε τις ειδοποιήσεις — ενεργοποίησέ τες στις ρυθμίσεις της συσκευής",
      set_bio: "Βιομετρικά",
      set_web: "Πλήρες web πάνελ",
      set_dev_panel: "Πάνελ Διαχείρισης (Dev)",
      set_dev_panel_sub: "Πλήρης πρόσβαση — όλες οι επιλογές του Dev",
      set_logout: "Αποσύνδεση",
      loading: "Φόρτωση…",
      error_generic: "Κάτι πήγε στραβά — δοκίμασε ξανά",
      no_access: "Δεν έχεις πρόσβαση σε αυτή την ενότητα",
      install_title: "Εγκατάσταση εφαρμογής",
      install_sub: "Για λόγους ασφαλείας, η εφαρμογή διαχείρισης ανοίγει μόνο ως εγκατεστημένη εφαρμογή από την αρχική σου οθόνη.",
      install_detected: "Εντοπίσαμε",
      install_now: "Εγκατάσταση",
      install_or_steps: "ή ακολούθησε τα βήματα",
      install_steps_title: "Ακολούθησε τα βήματα",
      install_chrome_1: "Πάτησε το μενού ⋮ πάνω δεξιά",
      install_chrome_2: "Διάλεξε «Προσθήκη στην αρχική οθόνη» ή «Εγκατάσταση εφαρμογής»",
      install_chrome_3: "Πάτησε «Εγκατάσταση»",
      install_samsung_1: "Πάτησε το μενού ☰ κάτω δεξιά",
      install_samsung_2: "Διάλεξε «Προσθήκη σελίδας σε»",
      install_samsung_3: "Διάλεξε «Αρχική οθόνη»",
      install_firefox_1: "Πάτησε το μενού ⋮",
      install_firefox_2: "Διάλεξε «Εγκατάσταση» ή «Προσθήκη στην αρχική οθόνη»",
      install_edge_1: "Πάτησε το μενού ☰ κάτω στο κέντρο",
      install_edge_2: "Διάλεξε «Προσθήκη στο τηλέφωνο»",
      install_safari_1: "Πάτησε το κουμπί Κοινής χρήσης στο κάτω μέρος της οθόνης",
      install_safari_2: "Κύλησε κάτω και διάλεξε «Προσθήκη στην οθόνη αφετηρίας»",
      install_safari_3: "Πάτησε «Προσθήκη» πάνω δεξιά",
      install_other_1: "Πάτησε το εικονίδιο εγκατάστασης στη γραμμή διευθύνσεων του browser",
      install_other_2: "Μετά άνοιξε την εφαρμογή από το εικονίδιό της",
      install_ios_other_title: "Στο iPhone χρειάζεσαι τον Safari",
      install_ios_other_text: "Η Apple επιτρέπει την εγκατάσταση εφαρμογών μόνο μέσω Safari. Αντίγραψε τον σύνδεσμο και άνοιξέ τον στον Safari.",
      install_copy_link: "Αντιγραφή συνδέσμου",
      install_copied: "Ο σύνδεσμος αντιγράφηκε — άνοιξέ τον στον Safari",
      install_after_title: "Μετά την εγκατάσταση",
      install_after_text: "Άνοιξε την εφαρμογή από το εικονίδιο «Care For Me» στην αρχική σου οθόνη — όχι από τον browser.",
      consent_title: "Συγκατάθεση δημοσίευσης",
      consent_msg: "Επιτρέπετε στο Care For Me να δημοσιεύει φωτογραφίες ή βίντεο του κατοικιδίου σας στην ιστοσελίδα και στα social media της επιχείρησης;",
      consent_hint: "Η απάντηση δίνεται από τον πελάτη — το ραντεβού ολοκληρώνεται κανονικά με κάθε επιλογή",
      consent_yes: "ΝΑΙ, ΣΥΜΦΩΝΩ",
      consent_no: "ΟΧΙ, ΔΕΝ ΣΥΜΦΩΝΩ",
      consent_saved: "Η συγκατάθεση αποθηκεύτηκε",
      consent_label: "Συγκατάθεση φωτο/βίντεο",
      consent_status_granted: "Έχει δώσει συγκατάθεση",
      consent_status_declined: "Δεν έχει δώσει συγκατάθεση",
      consent_status_none: "Δεν έχει καταγραφεί συγκατάθεση",
      consent_status_revoked: "Έχει ανακαλέσει τη συγκατάθεση",
      consent_set_yes: "Συμφωνεί",
      consent_set_no: "Δεν συμφωνεί",
      consent_set_revoke: "Ανάκληση",
      consent_history: "Ιστορικό συγκατάθεσης",
    },
    a11y: {
      title: "Προσβασιμότητα",
      subtitle: "Προσάρμοσε την εμπειρία σου",
      text_size: "Μέγεθος κειμένου",
      normal: "Κανονικό",
      large: "Μεγάλο",
      xl: "Πολύ μεγάλο",
      contrast: "Υψηλή αντίθεση",
      links: "Τόνισε συνδέσμους",
      motion: "Μείωση κινήσεων",
      reset: "Επαναφορά",
      open: "Άνοιγμα μενού προσβασιμότητας",
    },
    shop: {
      title: "Care For Me Boutique",
      subtitle: "Επιλεγμένα προϊόντα για τον τετράποδο φίλο σου — παραλαβή & πληρωμή στο κατάστημα.",
      search_ph: "Αναζήτηση προϊόντων...",
      hub_brands: "Συνεργάτες",
      hub_categories: "Κατηγορίες",
      hub_all: "Όλα τα προϊόντα",
      hub_all_hint: "Δες ολόκληρο τον κατάλογο του boutique",
      hub_back: "Πίσω στην επισκόπηση",
      all_categories: "Όλες οι κατηγορίες",
      all_brands: "Όλοι οι συνεργάτες",
      sort_newest: "Νεότερα",
      sort_price_asc: "Τιμή: αύξουσα",
      sort_price_desc: "Τιμή: φθίνουσα",
      sort_name: "Αλφαβητικά",
      avail_in_stock: "Άμεσα διαθέσιμο",
      avail_on_order: "Κατόπιν παραγγελίας",
      avail_unavailable: "Μη διαθέσιμο",
      sale_badge: "Προσφορά",
      add_to_cart: "Στο καλάθι",
      added: "Προστέθηκε στο καλάθι!",
      details: "Λεπτομέρειες",
      empty: "Δεν βρέθηκαν προϊόντα.",
      vat_note: "Οι τιμές περιλαμβάνουν ΦΠΑ.",
      select_variant: "Διάλεξε επιλογή",
      select_size: "Μέγεθος",
      select_color: "Χρώμα",
      legend_hint: "Ένδειξη: πράσινο = απόθεμα · πορτοκαλί = κατόπιν παραγγελίας · γκρι = εξαντλημένο",
      stock_left: "Απόθεμα:",
      max_stock: "Έως το διαθέσιμο απόθεμα",
      cart_title: "Το καλάθι μου",
      cart_empty: "Το καλάθι σου είναι άδειο.",
      qty: "Ποσότητα",
      remove: "Αφαίρεση",
      subtotal: "Υποσύνολο",
      discount: "Έκπτωση",
      total: "Σύνολο",
      checkout_btn: "Ολοκλήρωση παραγγελίας",
      continue_shopping: "Συνέχεια αγορών",
      checkout_title: "Ολοκλήρωση παραγγελίας",
      mode_login: "Σύνδεση",
      mode_register: "Νέος λογαριασμός",
      mode_guest: "Συνέχεια ως επισκέπτης",
      contact_details: "Τα στοιχεία σου",
      notes: "Σημειώσεις (προαιρετικό)",
      place_order: "Υποβολή παραγγελίας",
      placing: "Υποβολή...",
      summary: "Σύνοψη παραγγελίας",
      coupon_ph: "Κωδικός κουπονιού",
      coupon_apply: "Εφαρμογή",
      coupon_invalid: "Μη έγκυρο κουπόνι",
      pickup_note: "Παραλαβή & πληρωμή στο κατάστημα — μετρητά ή κάρτα στο ταμείο. Χωρίς αποστολές.",
      call_to_order: "Για παραγγελία αυτού του προϊόντος κάλεσέ μας ή πέρνα από το κατάστημα.",
      confirm_title: "Η παραγγελία σου καταχωρήθηκε!",
      confirm_body: "Θα σε ειδοποιήσουμε με email και SMS μόλις είναι έτοιμη για παραλαβή. Ισχύει για 5 εργάσιμες ημέρες από τότε.",
      order_number: "Αριθμός παραγγελίας",
      back_shop: "Πίσω στη Boutique",
      lookup_title: "Βρες την παραγγελία σου",
      lookup_btn: "Αναζήτηση",
      coming_soon_title: "Η Boutique έρχεται σύντομα!",
      coming_soon_body: "Ετοιμάζουμε μια μικρή, προσεκτικά επιλεγμένη συλλογή προϊόντων για τους τετράποδους φίλους σου. Μείνε συντονισμένος!",
      unlock_ph: "Κωδικός πρόσβασης",
      unlock_btn: "Είσοδος",
      unlock_error: "Λάθος κωδικός.",
      wishlist_add: "Προσθήκη στα αγαπημένα",
      wishlist_remove: "Αφαίρεση από αγαπημένα",
      wishlist_login: "Συνδέσου για να αποθηκεύσεις αγαπημένα",
      home_eyebrow: "Σύρε για περισσότερα",
      home_title: "Από τη Boutique μας",
      home_sub: "Μικρή, προσεκτικά επιλεγμένη συλλογή για τον τετράποδο φίλο σου — παραλαβή από το κατάστημα.",
      home_view_all: "Δες τη Boutique",
    },
    account: {
      title: "Ο λογαριασμός μου",
      subtitle: "Ραντεβού, παραγγελίες και στοιχεία — όλα σε ένα μέρος.",
      login: "Σύνδεση",
      register: "Εγγραφή",
      first_name: "Όνομα",
      last_name: "Επώνυμο (προαιρετικό)",
      email: "Email",
      phone: "Κινητό τηλέφωνο",
      phone_hint: "10 ψηφία, μορφή 69ΧΧΧΧΧΧΧΧ",
      password: "Κωδικός",
      login_btn: "Σύνδεση",
      logging_in: "Σύνδεση...",
      register_btn: "Δημιουργία λογαριασμού",
      registering: "Δημιουργία...",
      forgot_link: "Ξέχασα τον κωδικό μου",
      forgot_title: "Επαναφορά κωδικού",
      forgot_body: "Γράψε το email σου και θα σου στείλουμε σύνδεσμο επαναφοράς.",
      forgot_btn: "Αποστολή συνδέσμου",
      forgot_sent: "Αν υπάρχει λογαριασμός με αυτό το email, στείλαμε σύνδεσμο επαναφοράς.",
      guest_lookup: "Αναζήτηση ραντεβού χωρίς λογαριασμό",
      welcome: "Γεια σου",
      logout: "Αποσύνδεση",
      tab_home: "Αρχική",
      tab_bookings: "Τα ραντεβού μου",
      tab_orders: "Οι παραγγελίες μου",
      tab_profile: "Τα στοιχεία μου",
      tab_pets: "Τα κατοικίδιά μου",
      tab_wishlist: "Αγαπημένα",
      next_booking: "Επόμενο ραντεβού",
      no_upcoming: "Δεν υπάρχει προσεχές ραντεβού.",
      new_booking_btn: "Κλείσε ραντεβού",
      last_order: "Τελευταία παραγγελία",
      no_orders: "Δεν υπάρχουν παραγγελίες ακόμα.",
      go_shop: "Δες τη Boutique",
      upcoming: "Προσεχή",
      past: "Παλαιότερα",
      manage_bookings: "Διαχείριση ραντεβού (αλλαγή/ακύρωση)",
      bookings_empty: "Δεν βρέθηκαν ραντεβού για αυτόν τον λογαριασμό.",
      autolink_note: "Τα ραντεβού και οι παραγγελίες με το ίδιο email ή τηλέφωνο συνδέονται αυτόματα με τον λογαριασμό σου.",
      order_status: {
        new: "Νέα",
        preparing: "Σε προετοιμασία",
        awaiting_supplier: "Αναμονή προμηθευτή",
        ready: "Έτοιμη για παραλαβή",
        completed: "Ολοκληρώθηκε",
        cancelled: "Ακυρώθηκε",
        extended: "Επέκταση προθεσμίας",
        supply_to_order: "Προς παραγγελία",
        supply_ordered: "Παραγγέλθηκε από προμηθευτή",
        supply_received: "Παραλήφθηκε",
      },
      ready_until: "Παραλαβή έως",
      history: "Ιστορικό εξέλιξης",
      save: "Αποθήκευση",
      saving: "Αποθήκευση...",
      saved: "Τα στοιχεία αποθηκεύτηκαν.",
      change_password: "Αλλαγή κωδικού",
      current_password: "Τρέχων κωδικός",
      new_password: "Νέος κωδικός",
      password_changed: "Ο κωδικός άλλαξε.",
      delete_account: "Διαγραφή λογαριασμού",
      delete_body: "Ο λογαριασμός σου θα διαγραφεί οριστικά. Τα ραντεβού και οι παραγγελίες σου παραμένουν στο κατάστημα.",
      delete_password_ph: "Γράψε τον κωδικό σου για επιβεβαίωση",
      delete_confirm_btn: "Οριστική διαγραφή",
      deleted: "Ο λογαριασμός διαγράφηκε.",
      pets_empty: "Δεν βρέθηκαν κατοικίδια — εμφανίζονται αυτόματα από τα ραντεβού σου.",
      wishlist_empty: "Δεν έχεις αγαπημένα προϊόντα ακόμα.",
      orders_empty: "Δεν υπάρχουν παραγγελίες ακόμα.",
      visits: "επισκέψεις",
      reset_title: "Νέος κωδικός",
      reset_btn: "Αποθήκευση νέου κωδικού",
      reset_done: "Ο κωδικός άλλαξε! Συνδέσου με τον νέο κωδικό.",
      reset_invalid: "Ο σύνδεσμος έληξε ή δεν είναι έγκυρος.",
      items: "προϊόντα",
    },
    ashop: {
      nav_boutique: "Boutique",
      tab_overview: "Επισκόπηση",
      tab_products: "Προϊόντα",
      tab_categories: "Κατηγορίες",
      tab_suppliers: "Προμηθευτές",
      tab_orders: "Παραγγελίες",
      tab_stats: "Στατιστικά",
      tab_settings: "Ρυθμίσεις",
      new_orders: "Νέες παραγγελίες",
      ready_orders: "Έτοιμες προς παραλαβή",
      supplier_pending: "Σε αναμονή προμηθευτή",
      total_products: "Προϊόντα",
      add_product: "Νέο προϊόν",
      edit_product: "Επεξεργασία προϊόντος",
      name_gr: "Ονομασία (GR)",
      name_en: "Ονομασία (EN)",
      description_gr: "Περιγραφή (GR)",
      description_en: "Περιγραφή (EN)",
      price: "Τιμή (€, με ΦΠΑ)",
      brand: "Συνεργάτης",
      category: "Κατηγορία",
      supplier: "Προμηθευτής",
      none: "—",
      variants: "Επιλογές (μέγεθος/χρώμα/έκδοση)",
      add_variant: "Προσθήκη επιλογής",
      variant_label: "Ετικέτα (π.χ. Medium / Κόκκινο)",
      variant_price_ph: "€ (κενό = βασική)",
      variant_sale_ph: "προσφορά € (κενό = καμία)",
      stock: "Απόθεμα",
      availability: "Διαθεσιμότητα",
      eta: "Εργάσιμες έως παραλαβή",
      images: "Φωτογραφίες",
      img_all: "Όλες οι εκδόσεις",
      upload_image: "Ανέβασμα φωτογραφίας",
      active: "Ενεργό",
      online_orderable: "Να παραγγέλλεται online όταν είναι «κατόπιν παραγγελίας»",
      online_orderable_hint: "Αν το κλείσεις, ο πελάτης θα βλέπει να καλέσει ή να περάσει από το κατάστημα.",
      save: "Αποθήκευση",
      cancel: "Άκυρο",
      delete: "Διαγραφή",
      delete_confirm: "Σίγουρα θέλεις διαγραφή;",
      saved_toast: "Αποθηκεύτηκε.",
      deleted_toast: "Διαγράφηκε.",
      groomer_hint: "Βλέπεις τα προϊόντα και αλλάζεις μόνο τη διαθεσιμότητα.",
      order: "Παραγγελία",
      customer: "Πελάτης",
      items: "Προϊόντα",
      total: "Σύνολο",
      status: "Κατάσταση",
      date: "Ημερομηνία",
      actions: "Ενέργειες",
      statuses: {
        new: "Νέα",
        preparing: "Σε προετοιμασία",
        awaiting_supplier: "Αναμονή προμηθευτή",
        ready: "Έτοιμη για παραλαβή",
        completed: "Ολοκληρώθηκε",
        cancelled: "Ακυρώθηκε",
        extended: "Επέκταση προθεσμίας",
        supply_to_order: "Προς παραγγελία",
        supply_ordered: "Παραγγέλθηκε",
        supply_received: "Παραλήφθηκε",
      },
      history: "Ιστορικό αλλαγών",
      ready_deadline: "Προθεσμία παραλαβής",
      extend_btn: "Επέκταση",
      extend_days: "ημέρες",
      extended_toast: "Η προθεσμία επεκτάθηκε.",
      status_toast: "Η κατάσταση άλλαξε.",
      ready_blocked: "Δεν έχουν παραληφθεί όλα τα προϊόντα.",
      supplier_orders_title: "Παραγγελίες προς προμηθευτές",
      supplier_orders_hint: "Προϊόντα που παρήγγειλαν πελάτες και δεν υπάρχουν σε απόθεμα, ομαδοποιημένα ανά προμηθευτή.",
      no_supplier_items: "Τίποτα σε εκκρεμότητα — όλα καλά!",
      stage_to_order: "Προς παραγγελία",
      stage_ordered: "Παραγγέλθηκε",
      stage_received: "Παραλήφθηκε",
      mark_ordered: "Σήμανση «Παραγγέλθηκε»",
      mark_received: "Σήμανση «Παραλήφθηκε»",
      qty_short: "×",
      for_order: "για παραγγελία",
      add_category: "Νέα κατηγορία",
      add_supplier: "Νέος προμηθευτής",
      contact: "Επαφή",
      notes: "Σημειώσεις",
      empty_products: "Δεν υπάρχουν προϊόντα ακόμα. Πρόσθεσε το πρώτο!",
      empty_orders: "Δεν υπάρχουν παραγγελίες ακόμα.",
      empty_categories: "Δεν υπάρχουν κατηγορίες.",
      stats_total: "Σύνολο παραγγελιών",
      stats_revenue: "Έσοδα (ολοκληρωμένες)",
      stats_ready_value: "Αξία ετοίμων προς παραλαβή",
      stats_top: "Δημοφιλέστερα προϊόντα",
      settings_title: "Ρυθμίσεις Boutique",
      eshop_enabled: "Boutique ενεργό (δημόσιο)",
      eshop_hidden: "Αφαίρεση από το μενού της σελίδας",
      access_password: "Κωδικός προεπισκόπησης (για είσοδο όταν είναι κλειστό)",
      access_password_set: "Έχει οριστεί κωδικός",
      access_password_ph: "Νέος κωδικός (άδειο = παραμένει ο ίδιος)",
      settings_saved: "Οι ρυθμίσεις αποθηκεύτηκαν.",
      coupon_badge: "Κουπόνι",
      home_section: "Ενότητα Boutique στην αρχική σελίδα",
      featured_title: "Προϊόντα αρχικής σελίδας (έως 8)",
      featured_hint: "Πάτα πάνω στα προϊόντα με τη σειρά που θες να εμφανίζονται.",
      featured_none: "Κανένα επιλεγμένο — η ενότητα δεν εμφανίζεται στην αρχική.",
      tab_colors: "Χρώματα",
      colors_title: "Βιβλιοθήκη χρωμάτων",
      colors_hint: "Γενικά χρώματα που τα διαλέγεις σε κάθε προϊόν. Η φωτογραφία εμφανίζεται δίπλα στην επιλογή χρώματος.",
      color_name_gr: "Όνομα χρώματος (GR)",
      color_name_en: "Όνομα χρώματος (EN)",
      add_color: "Νέο χρώμα",
      empty_colors: "Δεν υπάρχουν χρώματα ακόμα.",
      color_photo: "Φωτογραφία χρώματος",
      sizes_label: "Διαθέσιμα μεγέθη",
      sizes_hint: "Γράψε μέγεθος και πάτα Enter (π.χ. S, M, L)",
      sizes_ph: "π.χ. Medium",
      colors_label: "Διαθέσιμα χρώματα",
      colors_empty_hint: "Πρόσθεσε πρώτα χρώματα στην καρτέλα «Χρώματα».",
      custom_axis_label: "Τρίτη επιλογή (προαιρετικό)",
      custom_axis_name_gr: "Τίτλος επιλογής (GR) — π.χ. Υλικό",
      custom_axis_name_en: "Τίτλος επιλογής (EN)",
      custom_axis_options: "Επιλογές",
      custom_axis_ph: "Γράψε επιλογή και πάτα Enter (π.χ. Δέρμα)",
      combos_generate: "Δημιουργία συνδυασμών",
      combos_replace_hint: "Θα αντικατασταθούν οι υπάρχοντες συνδυασμοί που έχουν μέγεθος/χρώμα.",
      combo_size: "Μέγεθος",
      combo_color: "Χρώμα",
      manual_options: "Απλές επιλογές (χωρίς μέγεθος/χρώμα)",
      search_products: "Αναζήτηση προϊόντος...",
      search_no_results: "Δεν βρέθηκε προϊόν.",
      price_inline: "Τιμή παραλλαγής (κενό = βασική τιμή)",
      sale_inline: "Τιμή προσφοράς (κενό = καμία)",
      colors_badge: "Σήμα «X Χρώματα» πάνω στη φωτογραφία προϊόντος",
      drag_hint: "Σύρε για αλλαγή σειράς εμφάνισης",
      cat_photo: "Φωτογραφία κατηγορίας",
      brands_photos_title: "Φωτογραφίες συνεργατών",
      brands_photos_hint: "Οι προμηθευτές εμφανίζονται αυτόματα εδώ και μπορούν να πάρουν φωτογραφία. Στη δημόσια σελίδα δείχνουν μόνο όσοι έχουν προϊόντα.",
    },
    themes: {
      nav: "THEMES",
      title: "Εποχικά θέματα",
      hint: "Ενεργοποίησε ένα θέμα και ολόκληρη η δημόσια σελίδα ντύνεται με την εποχή — χρώματα, διακόσμηση και animations. Ένα θέμα τη φορά.",
      activate: "Ενεργοποίηση",
      deactivate: "Απενεργοποίηση",
      on_toast: "Το θέμα ενεργοποιήθηκε!",
      off_toast: "Το θέμα απενεργοποιήθηκε",
      splash_label: "Εορταστικό Splash Screen",
      splash_hint: "Στην είσοδο της σελίδας (με θέμα Χριστούγεννα): λογότυπο, ημέρες ως τα Χριστούγεννα / την Πρωτοχρονιά και ένδειξη φόρτωσης για 4 δευτερόλεπτα.",
      splash_on: "Το splash screen ενεργοποιήθηκε",
      splash_off: "Το splash screen απενεργοποιήθηκε",
      splash_xmas: "Ημέρες ως τα Χριστούγεννα",
      splash_newyear: "Ημέρες ως την Πρωτοχρονιά",
      splash_loading: "Φορτώνεται η σελίδα...",
      names: { christmas: "Χριστούγεννα", halloween: "Halloween", apokries: "Απόκριες", easter: "Πάσχα", summer: "Καλοκαίρι" },
      desc: {
        christmas: "Χιονόνιφαδες, λαμπάκια και ζεστά γιορτινά χρώματα",
        halloween: "Κολοκύθες, νυχτερίδες, αχνές αράχνης και φαντάσματα",
        apokries: "Κομφετί, σερπαντίνες και καρναβαλικές μάσκες",
        easter: "Πασχαλινά αυγά, λουλούδια και πεταλούδες που πετούν",
        summer: "Κύματα, ήλιος και καλοκαιρινή διάθεση στα κουμπιά",
      },
    },
    popup: {
      title: "Popup σελίδας",      subtitle: "Αναδυόμενο μήνυμα που βλέπουν οι επισκέπτες μία φορά ανά επίσκεψη.",
      enabled: "Ενεργό popup",
      icon: "Εικονίδιο",
      ptitle: "Τίτλος",
      text: "Κείμενο",
      btn: "Κουμπί",
      btn_none: "Χωρίς κουμπί",
      btn_section: "Πηγαίνει σε σημείο της σελίδας",
      btn_url: "Εξωτερικός σύνδεσμος",
      btn_label: "Λεζάντα κουμπιού",
      section: "Σημείο σελίδας",
      url: "Σύνδεσμος (https://...)",
      save: "Αποθήκευση popup",
      saved: "Το popup αποθηκεύτηκε.",
      preview: "Προεπισκόπηση",
      sections: {
        about: "Σχετικά",
        services: "Υπηρεσίες",
        nagayu: "Nagayu",
        selfwash: "Self Service",
        grooming: "Κράτηση Grooming",
        gallery: "Ο Χώρος",
        contact: "Επικοινωνία",
        shop: "Boutique",
      },
    },
    admin: {
      login_title: "Είσοδος Διαχειριστή",
      login_sub: "Care For Me — Πίνακας διαχείρισης",
      email: "Email ή Username",
      password: "Κωδικός",
      login: "Σύνδεση",
      logging: "Σύνδεση...",
      logout: "Αποσύνδεση",
      dashboard: "Πίνακας Ελέγχου",
      bookings: "Αιτήματα Grooming",
      selfwash: "Self-Service",
      messages: "Μηνύματα",
      total_bookings: "Σύνολο ραντεβού",
      pending: "Σε αναμονή",
      total_messages: "Σύνολο μηνυμάτων",
      unread: "Αδιάβαστα",
      total_selfwash: "Κρατήσεις Self-Service",
      selfwash_today: "Σήμερα",
      revenue: "Έσοδα Self-Service",
      no_bookings: "Δεν υπάρχουν αιτήματα ακόμη.",
      no_messages: "Δεν υπάρχουν μηνύματα ακόμη.",
      no_selfwash: "Δεν υπάρχουν κρατήσεις ακόμη.",
      search: "Αναζήτηση...",
      all: "Όλα",
      status: "Κατάσταση",
      actions: "Ενέργειες",
      login_error: "Λάθος στοιχεία σύνδεσης.",
      refresh: "Ανανέωση",
      landing_pages: "Landing Pages",
      landing_grooming: "Landing Grooming",
      landing_self: "Landing Self",
      new_booking_title: "Νέο Ραντεβού!",
      new_booking_body: "Έχετε νέες κρατήσεις που περιμένουν.",
      accept: "Αποδοχή",
      sound_on: "Ήχος: Ενεργός",
      sound_off: "Ήχος: Ανενεργός",
      completed: "Ολοκληρωμένα",
      no_completed: "Δεν υπάρχουν ολοκληρωμένα ακόμη.",
      email_sent_badge: "Email στάλθηκε",
      email_not_sent_badge: "Στείλε τώρα",
      email_none: "Χωρίς email",
      email_send_title: "Στείλε email επιβεβαίωσης στον πελάτη",
      email_sent_toast: "Το email στάλθηκε στον πελάτη",
      email_send_error: "Αποτυχία αποστολής email",
      reminder_sent_badge: "Υπενθύμιση στάλθηκε",
      reminder_at: "Υπενθύμιση",
      reminder_not_scheduled: "χωρίς προγραμματισμό",
      reminder_send_now: "Στείλε τώρα",
      reminder_send_title: "Στείλε την υπενθύμιση τώρα",
      reminder_edit_title: "Άλλαξε την ώρα υπενθύμισης",
      reminder_manual_label: "Υπενθύμιση",
      reminder_manual_title: "Αποστολή SMS υπενθύμισης τώρα (εκτός προγραμματισμένης)",
      reminder_manual_confirm: "Να σταλεί SMS υπενθύμισης στον πελάτη; ({n}/2 χειροκίνητες)",
      reminder_manual_sent: "Η υπενθύμιση στάλθηκε",
      review_prompt_title: "Να σταλεί SMS κριτικής;",
      review_prompt_body: "Το ραντεβού ολοκληρώθηκε. Να σταλεί στον πελάτη ευχαριστήριο SMS με σύνδεσμο για κριτική στο Google;",
      review_prompt_send: "Ναι, στείλε",
      review_prompt_skip: "Όχι",
      review_sent_toast: "Το SMS κριτικής στάλθηκε",
      discount_applied: "Έκπτωση",
      winback_title: "Πελάτες που λείπουν",
      winback_sub: "Δεν έχουν έρθει πάνω από 1 μήνα και δεν έχουν επερχόμενο ραντεβού",
      winback_empty: "Κανείς δεν λείπει αυτόν τον καιρό — όλοι έχουν περάσει πρόσφατα!",
      winback_count: "{n} πελάτες λείπουν πάνω από μήνα",
      winback_days_away: "πριν από {n} ημέρες",
      winback_last: "Τελευταία: {d}",
      winback_send: "Αποστολή",
      winback_message: "Μήνυμα",
      winback_history: "Προηγούμενες αποστολές",
      winback_confirm: "Να σταλεί σε {n} πελάτη(ες) μέσω {channel};",
      winback_sent: "Εστάλησαν: {s} · Απέτυχαν: {f}",
      winback_low_credits: "Επικοινωνήστε με τον διαχειριστή της σελίδας για την αποστολή του μηνύματος (χαμηλό υπόλοιπο SMS)",
      winback_personalized: "Κάθε πελάτης θα λάβει το μήνυμα με το δικό του όνομα",
      winback_preview_for: "Προεπισκόπηση για: {name}",
      winback_locked: "Κλειδωμένο πρότυπο — η επεξεργασία γίνεται από τον διαχειριστή",
      coupon_add: "Προσθήκη κουπονιού έκπτωσης",
      coupon_kind: "Είδος",
      coupon_percent: "Ποσοστό %",
      coupon_euro: "Ευρώ €",
      coupon_amount: "Ποσό",
      coupon_expires: "Λήξη",
      coupon_service: "Υπηρεσία",
      coupon_selfwash: "Self-Service",
      coupon_grooming: "Grooming",
      coupon_both: "Και τα δύο",
      coupon_note: "Μοναδικός κωδικός ανά πελάτη, μιας χρήσης, δεμένος με το τηλέφωνό του.",
      reminder_confirm_send: "Θέλεις να σταλεί η υπενθύμιση τώρα;",
      reminder_sent_toast: "Η υπενθύμιση στάλθηκε",
      reminder_schedule_saved: "Προγραμματισμός υπενθύμισης αποθηκεύτηκε",
      reminder_dialog: {
        title: "Προγραμματισμός υπενθύμισης",
        subtitle: "Διάλεξε ημερομηνία και ώρα αποστολής",
        date_label: "Ημερομηνία",
        time_label: "Ώρα",
        hour: "Ώρα",
        minute: "Λεπτά",
      },
      sms: {
        title: "SMS Υπενθυμίσεις",
        subtitle: "Αυτόματα SMS: επιβεβαίωση κράτησης, αλλαγές και υπενθύμιση 24 ώρες πριν",
        on: "Ενεργό",
        off: "Ανενεργό",
        toggled_on: "Οι SMS υπενθυμίσεις ενεργοποιήθηκαν",
        toggled_off: "Οι SMS υπενθυμίσεις απενεργοποιήθηκαν",
        test_send: "Αποστολή δοκιμαστικού SMS",
        test_sending: "Αποστολή...",
        test_placeholder: "69XXXXXXXX",
        test_success: "Το δοκιμαστικό SMS στάλθηκε!",
        last_attempt: "Τελευταία απόπειρα",
        never: "καμία ακόμη",
        badge_pending: "SMS",
        badge_sent: "SMS στάλθηκε",
        badge_failed: "SMS απέτυχε",
        resend: "Ξαναστείλε",
        resent_toast: "Το SMS στάλθηκε ξανά",
        send_error: "Αποτυχία αποστολής SMS",
        toggle_error: "Αποτυχία αλλαγής ρύθμισης",
        history_button: "Ιστορικό SMS",
        balance: "Υπόλοιπο",
        history_title: "Ιστορικό SMS",
        history_subtitle: "Όλα τα SMS που έχουν σταλεί",
        history_empty: "Δεν έχουν σταλεί SMS ακόμη.",
        history_refresh: "Ανανέωση",
        success: "Επιτυχία",
        failed: "Αποτυχία",
        kinds: { test: "Δοκιμαστικό", confirmation: "Επιβεβαίωση", edit: "Αλλαγή", reminder: "Υπενθύμιση" },
      },
      email_history: {
        button: "Ιστορικό Email",
        title: "Ιστορικό Email",
        subtitle: "Όλα τα email που έχουν σταλεί",
        empty: "Δεν έχουν σταλεί email ακόμη.",
        view_content: "Περιεχόμενο",
        kinds: { admin: "Ειδοποίηση καταστήματος", confirmation: "Επιβεβαίωση", edit: "Αλλαγή", cancel: "Ακύρωση", reminder: "Υπενθύμιση", bulk: "Μαζικό" },
      },
      month_cal: { weekdays: ["Δε", "Τρ", "Τε", "Πε", "Πα", "Σα", "Κυ"] },
      today_agenda: "Σημερινά ραντεβού",
      no_today: "Κανένα ραντεβού σήμερα",
      ack_button: "Ενημερώθηκα!",
      day_bookings: "Ραντεβού ημέρας",
      role_groomer: "Κατάστημα",
      role_dev: "Dev",
      tab_analytics: "Analytics",
      tab_customers: "Πελάτες",
      tab_gallery: "Gallery",
      tab_messaging: "SMS & Email",
      tab_settings: "Ρυθμίσεις",
      tab_all: "Όλα",
      dev: {
        visits: "Επισκέψεις",
        bookings_14d: "Κρατήσεις (14 ημέρες)",
        messages_14d: "Μηνύματα (14 ημέρες)",
        vs_prev: "vs προηγ. 14 ημέρες",
        per_page: "Προβολές ανά σελίδα",
        weekly_revenue: "Έσοδα Self-Service ανά εβδομάδα",
        month_compare: "Μηνιαία σύγκριση",
        bookings: "Κρατήσεις",
        revenue: "Έσοδα Self-Service",
        this_month: "Τρέχων μήνας",
        last_month: "Προηγούμενος μήνας",
        customers_title: "Πελάτες",
        customers_sub: "Μοναδικοί πελάτες από όλα τα ραντεβού",
        col_customer: "Πελάτης",
        col_bookings: "Ραντεβού",
        col_revenue: "Έσοδα",
        col_last: "Τελευταίο ραντεβού",
        bulk_title: "Μαζική αποστολή σε πελάτες",
        bulk_message: "Μήνυμα",
        bulk_channel_sms: "SMS",
        bulk_channel_email: "Email",
        bulk_recipients: "παραλήπτες",
        bulk_est_cost: "Εκτιμώμενη χρέωση",
        bulk_credits: "credits",
        bulk_send: "Αποστολή",
        bulk_sending: "Αποστολή...",
        bulk_confirm_sms: "Να σταλεί SMS σε {n} πελάτες (~{c} credits);",
        bulk_confirm_email: "Να σταλεί email σε {n} πελάτες;",
        bulk_done: "Ολοκληρώθηκε: {s}/{t} επιτυχή",
        bulk_sms_off: "Ο διακόπτης SMS είναι OFF — ενεργοποίησέ τον πρώτα",
        gallery_title: "Διαχείριση Gallery",
        gallery_sub: "Ανέβασε, διέγραψε ή αναδιάταξε φωτογραφίες της σελίδας",
        gallery_upload: "Ανέβασμα φωτογραφίας",
        gallery_uploading: "Ανέβασμα...",
        gallery_delete_confirm: "Να διαγραφεί αυτή η φωτογραφία;",
        gallery_empty: "Καμία φωτογραφία.",
        gallery_deleted: "Η φωτογραφία διαγράφηκε",
        gallery_uploaded: "Η φωτογραφία ανέβηκε",
        health_title: "Πιθανά προβλήματα",
        health_all_ok: "Όλα δείχνουν καλά",
        closures_title: "Αργίες / Κλειστές ημέρες",
        closures_from: "Από",
        closures_to: "Έως",
        closures_reason: "Αιτία (προαιρετικό)",
        closures_add: "Προσθήκη",
        closures_save: "Αποθήκευση αργιών",
        closures_saved: "Οι αργίες αποθηκεύτηκαν",
        closures_empty: "Καμία αργία — το κατάστημα ακολουθεί το κανονικό ωράριο",
        closures_popup: "Εμφάνιση popup στο site",
        closures_popup_text: "Κείμενο popup (π.χ. Κλειστά για διακοπές)",
        weekly_title: "Εβδομαδιαίες ώρες Grooming",
        weekly_sub: "Βασικές διαθέσιμες ώρες ανά ημέρα, χωρισμένες με κόμμα",
        weekly_placeholder: "π.χ. 11:00, 14:00, 17:00",
        weekly_save: "Αποθήκευση ωρών",
        weekly_saved: "Οι εβδομαδιαίες ώρες αποθηκεύτηκαν",
        hours_title: "Ωράριο λειτουργίας",
        hours_sub: "Έως 2 παράθυρα ανά ημέρα (π.χ. 12:00–14:30 και 17:30–20:30). Άδειο = κλειστά.",
        hours_save: "Αποθήκευση ωραρίου",
        hours_saved: "Το ωράριο αποθηκεύτηκε",
        day_names: ["Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο", "Κυριακή"],
        nav_overview: "Επισκόπηση",
        nav_templates: "Templates",
        nav_system: "Σύστημα",
        dev_badge: "DEV ENVIRONMENT",
        menu_open: "Μενού",
        ov_today: "Σήμερα",
        ov_pending: "Σε αναμονή",
        ov_week: "Επόμενες 7 ημέρες",
        ov_messages: "Νέα μηνύματα",
        quick_actions: "Γρήγορες ενέργειες",
        search_customers: "Αναζήτηση (όνομα, τηλέφωνο, email, κατοικίδιο, ράτσα)...",
        profile_title: "Προφίλ πελάτη",
        profile_history: "Ιστορικό ραντεβού",
        profile_notes: "Σημειώσεις πελάτη",
        note_placeholder: "Νέα σημείωση... (π.χ. ο σκύλος φοβάται το πιστολάκι)",
        note_add: "Προσθήκη",
        note_empty: "Καμία σημείωση ακόμα",
        note_edit: "Επεξεργασία",
        note_save: "Αποθήκευση",
        last_visit_label: "Τελευταία επίσκεψη",
        select_all: "Όλοι",
        select_none: "Κανένας",
        selected_recipients: "{n} επιλεγμένοι παραλήπτες",
        no_recipients: "Επίλεξε πρώτα παραλήπτες",
        templates_title: "SMS Templates",
        templates_sub: "Τα αυτόματα SMS που λαμβάνουν οι πελάτες. Placeholders: {name}, {date}, {time}, {link}. Η υπογραφή «Care For Me» προστίθεται αυτόματα στο τέλος.",
        tpl_confirmation: "SMS Επιβεβαίωσης",
        tpl_edit: "SMS Αλλαγής ραντεβού",
        tpl_reminder: "SMS Υπενθύμισης (24h πριν)",
        tpl_review: "SMS Κριτικής (Google review link)",
        tpl_winback: "SMS Win-back (πελάτες που λείπουν)",
        tpl_order_confirmation: "SMS επιβεβαίωσης παραγγελίας Boutique — {name} {order}",
        tpl_order_ready: "SMS «έτοιμη για παραλαβή» — {name} {order} {date}",
        accounts_title: "Εγγεγραμμένοι λογαριασμοί",
        accounts_sub: "Πελάτες με λογαριασμό στο careforme.gr — κλικ για λεπτομέρειες",
        account_badge: "Λογαριασμός",
        account_none: "Δεν έχει δημιουργήσει λογαριασμό ακόμα.",
        account_registered: "Εγγραφή",
        account_send_reset: "Email επαναφοράς κωδικού",
        account_reset_sent: "Στάλθηκε το email επαναφοράς στον πελάτη.",
        account_delete: "Διαγραφή λογαριασμού",
        account_delete_confirm: "Να διαγραφεί οριστικά ο λογαριασμός; Τα ραντεβού και οι παραγγελίες παραμένουν.",
        account_deleted: "Ο λογαριασμός διαγράφηκε.",
        coupons_title: "Κουπόνια",
        coupon_new: "Νέο κουπόνι",
        coupon_create: "Δημιουργία",
        coupon_created: "Το κουπόνι δημιουργήθηκε",
        coupon_used: "Χρησιμοποιήθηκε",
        coupon_active: "Ενεργό",
        coupon_expired: "Έληξε",
        coupon_everywhere: "Ισχύει παντού: grooming, self-service και Boutique.",
        coupon_sms_ask: "Να σταλεί SMS στον πελάτη με το κουπόνι;",
        coupon_sms_sent: "Το SMS με το κουπόνι στάλθηκε",
        orders_title: "Παραγγελίες Boutique",
        wishlist_label: "αγαπημένα",
        cust_add: "Νέος πελάτης",
        cust_add_sub: "Χειροκίνητη προσθήκη χωρίς ραντεβού — το κατάστημα θα τον βρίσκει ως υπάρχοντα πελάτη",
        cust_name: "Ονοματεπώνυμο",
        cust_phone_l: "Τηλέφωνο",
        cust_email_l: "Email (προαιρετικό)",
        cust_pet: "Κατοικίδιο (προαιρετικό)",
        cust_breed: "Ράτσα",
        cust_size: "Μέγεθος",
        cust_note_l: "Σημείωση (προαιρετικά)",
        cust_save: "Αποθήκευση πελάτη",
        cust_saved: "Ο πελάτης προστέθηκε",
        size_small: "Μικρό",
        size_medium: "Μεσαίο",
        size_large: "Μεγάλο",
        size_giant: "Γίγαντας",
        past_add: "Παλιό ραντεβού",
        past_title: "Προσθήκη παλιού ραντεβού",
        past_sub: "Καταχωρείται ως ολοκληρωμένο — δεν στέλνεται SMS/email στον πελάτη",
        past_type: "Τύπος",
        past_date: "Ημερομηνία",
        past_time: "Ώρα",
        past_service: "Υπηρεσία (προαιρετικά)",
        past_plan: "Πλάνο",
        past_price: "Τιμή € (προαιρετικά)",
        past_notes: "Σημείωση (προαιρετικά)",
        past_save: "Καταχώρηση",
        past_saved: "Το παλιό ραντεβού καταχωρήθηκε",
        past_badge: "Χειροκίνητο",
        nav_reviews: "Κριτικές",
        rev_title: "Κριτικές πελατών",
        rev_sub: "Οι ορατές κριτικές εμφανίζονται στην αρχική σελίδα",
        rev_add: "Νέα κριτική",
        rev_name: "Όνομα (π.χ. Μαρία Κ.)",
        rev_text: "Κείμενο κριτικής",
        rev_rating: "Αστέρια",
        rev_sort: "Σειρά",
        rev_visible: "Ορατή",
        rev_hidden: "Κρυφή",
        rev_edit: "Επεξεργασία",
        rev_save: "Αποθήκευση",
        rev_saved: "Η κριτική αποθηκεύτηκε",
        rev_deleted: "Η κριτική διαγράφηκε",
        rev_delete_confirm: "Να διαγραφεί οριστικά η κριτική;",
        rev_empty: "Καμία κριτική ακόμα — προσθέστε την πρώτη",
        rev_google_url: "Σύνδεσμος «Βαθμολογήστε μας στο Google»",
        rev_google_hint: "Άδειο = αυτόματη αναζήτηση της επιχείρησης στα Google Maps",
        rev_google_save: "Αποθήκευση συνδέσμου",
        rev_google_saved: "Ο σύνδεσμος αποθηκεύτηκε",
        nav_app_users: "Χρήστες εφαρμογής",
        nav_app_mobile: "Εφαρμογή κινητού",
        au_title: "Χρήστες εφαρμογής κινητού",
        au_sub: "Πρόσβαση στο «Care For Me Διαχείριση» με προσωπικό κωδικό — ξεχωριστά από τους λογαριασμούς της σελίδας",
        au_add: "Νέος χρήστης",
        au_name: "Όνομα (π.χ. Άννα)",
        au_code: "Κωδικός πρόσβασης (4–12 χαρακτήρες)",
        au_code_edit_hint: "Άδειο = παραμένει ο τρέχων",
        au_perms: "Δικαιώματα",
        perm_schedule: "Πρόγραμμα",
        perm_bookings: "Διαχείριση ραντεβού",
        perm_customers: "Πελατολόγιο",
        perm_orders: "Παραγγελίες",
        perm_messages: "Μηνύματα",
        perm_notifications: "Ειδοποιήσεις",
        perm_desc_schedule: "Βλέπει το ημερολόγιο και τα ραντεβού κάθε ημέρας",
        perm_desc_bookings: "Κλείνει νέα ραντεβού (wizard) και αλλάζει κατάσταση — ολοκλήρωση/ακύρωση",
        perm_desc_customers: "Αναζήτηση πελατών, καρτέλα πελάτη, ιστορικό και σημειώσεις",
        perm_desc_orders: "Βλέπει τις παραγγελίες της boutique και αλλάζει την κατάστασή τους",
        perm_desc_messages: "Βλέπει και διαβάζει τα εισερχόμενα μηνύματα επικοινωνίας",
        perm_desc_notifications: "Λαμβάνει push ειδοποίηση στη συσκευή του για νέο ραντεβού ή παραγγελία",
        au_active: "Ενεργός",
        au_inactive: "Απενεργοποιημένος",
        au_edit: "Επεξεργασία",
        au_save: "Αποθήκευση",
        au_saved: "Ο χρήστης αποθηκεύτηκε",
        au_deleted: "Ο χρήστης διαγράφηκε",
        au_delete_confirm: "Να διαγραφεί οριστικά ο χρήστης;",
        au_empty: "Κανένας χρήστης εφαρμογής ακόμα — δημιουργήστε τον πρώτο",
        au_badge: "Ρόλος",
        badge_store: "Κατάστημα",
        badge_management: "Διαχείριση",
        au_badge_hint: "Η «Διαχείριση» έχει αυτόματα ΟΛΑ τα δικαιώματα και ανοίγει το πλήρες Dev πάνελ μέσα από την εφαρμογή",
        am_title: "Εφαρμογή κινητού",
        am_sub: "Εγκατάσταση του «Care For Me Διαχείριση» στα κινητά του προσωπικού",
        am_link: "Σύνδεσμος εφαρμογής",
        am_copied: "Ο σύνδεσμος αντιγράφηκε",
        am_android_title: "Android",
        am_android_1: "Άνοιξε τον σύνδεσμο στο Chrome του κινητού",
        am_android_2: "Πάτησε το μενού ⋮ → «Εγκατάσταση εφαρμογής» / «Προσθήκη στην αρχική οθόνη»",
        am_android_3: "Η εφαρμογή εμφανίζεται ως κανονικό εικονίδιο και υποστηρίζει ειδοποιήσεις",
        am_android_apk: "Για υπογεγραμμένο APK: άνοιξε pwabuilder.com, βάλε τον σύνδεσμο, πάτα «Package for Android» και κατέβασε το APK",
        am_ios_title: "iPhone / iPad",
        am_ios_1: "Άνοιξε τον σύνδεσμο στο Safari",
        am_ios_2: "Πάτησε Κοινοποίηση → «Προσθήκη στην αρχική οθόνη»",
        am_ios_3: "Οι ειδοποιήσεις λειτουργούν σε iOS 16.4 και νεότερο",
        am_note: "Η είσοδος γίνεται με τον προσωπικό κωδικό που ορίζεις στους «Χρήστες εφαρμογής».",
        am_push_title: "Αποστολή ειδοποίησης στα κινητά",
        am_push_t: "Τίτλος",
        am_push_msg: "Μήνυμα",
        am_push_target: "Παραλήπτης",
        am_push_all: "Όλοι (με δικαίωμα ειδοποιήσεων)",
        am_push_send: "Αποστολή ειδοποίησης",
        am_push_sent: "Στάλθηκε σε {n} συσκευές",
        am_push_none: "Καμία συσκευή εγγεγραμμένη — ενεργοποιήστε τις ειδοποιήσεις από την εφαρμογή (Ρυθμίσεις)",
        tpl_save: "Αποθήκευση templates",
        tpl_saved: "Τα templates αποθηκεύτηκαν",
        tpl_reset: "Επαναφορά προεπιλογών",
        tpl_reset_done: "Επαναφέρθηκαν τα αρχικά κείμενα",
        tpl_preview: "Προεπισκόπηση",
        system_title: "Κατάσταση συστήματος",
        system_sms_log: "Πρόσφατες αποστολές SMS",
        system_no_logs: "Καμία αποστολή ακόμα",
        system_delivery_note: "Το SMSBox δεν παρέχει ξεχωριστές αναφορές παράδοσης — εδώ φαίνεται το αποτέλεσμα αποστολής από τον λογαριασμό.",
        export_csv: "Export CSV",
        export_done: "Το αρχείο κατέβηκε",
        refresh: "Ανανέωση",
        logout: "Αποσύνδεση",
        closures_single_day: "Μία μόνο ημέρα",
        closures_date: "Ημερομηνία",
        nav_announcement: "Ανακοίνωση",
        ann_form_title: "Νέα ανακοίνωση προς το κατάστημα",
        ann_form_sub: "Θα εμφανιστεί ως popup στον πίνακα του καταστήματος μέχρι να πατήσει «Ενημερώθηκα!».",
        ann_title: "Τίτλος",
        ann_body: "Κείμενο",
        ann_icon: "Εικονίδιο",
        ann_attachment: "Συνημμένο (προαιρετικό)",
        ann_attachment_pick: "Επιλογή αρχείου",
        ann_send: "Δημοσίευση",
        ann_sending: "Δημοσίευση...",
        ann_sent: "Η ανακοίνωση δημοσιεύτηκε",
        ann_list: "Προηγούμενες ανακοινώσεις",
        ann_empty: "Καμία ανακοίνωση ακόμα",
        ann_seen: "Το είδαν: {n}",
        ann_unseen: "Δεν το έχει δει ακόμα",
        ann_delete_confirm: "Να διαγραφεί η ανακοίνωση;",
        prices_title: "Τιμές πλάνων Self-Service",
        prices_save: "Αποθήκευση τιμών",
        prices_saved: "Οι τιμές αποθηκεύτηκαν",
        password_title: "Αλλαγή κωδικού",
        password_current: "Τρέχων κωδικός",
        password_new: "Νέος κωδικός (min 6)",
        password_save: "Αλλαγή κωδικού",
        password_saved: "Ο κωδικός άλλαξε επιτυχώς",
        links_title: "Γρήγοροι σύνδεσμοι",
        filter_type: "Τύπος",
        filter_status: "Κατάσταση",
        filter_all: "Όλα",
        grooming_type: "Grooming",
        selfwash_type: "Self-Service",
      },
      edit: "Επεξεργασία",
      edit_title: "Επεξεργασία Κράτησης",
      save: "Αποθήκευση",
      saving: "Αποθήκευση...",
      cancel: "Ακύρωση",
      saved: "Οι αλλαγές αποθηκεύτηκαν",
      saved_with_email: "Αποθηκεύτηκε · Στάλθηκε ειδοποίηση στον πελάτη",
      notify_customer_question: "Θέλεις να σταλεί email και SMS στον πελάτη με τις αλλαγές;",
      save_error: "Αποτυχία αποθήκευσης",
      grooming_type: "Grooming",
      selfwash_type: "Self-Service",
      statuses: { pending: "Σε αναμονή", contacted: "Επικοινωνία", confirmed: "Επιβεβαιωμένο", done: "Ολοκληρώθηκε", cancelled: "Ακυρώθηκε", no_show: "Δεν ήρθε" },
      slots: {
        open_button: "Ώρες Grooming",
        title: "Διαχείριση Ωρών Grooming",
        subtitle: "Πρόσθεσε ή αφαίρεσε ώρες ανά ημερομηνία",
        date_label: "Ημερομηνία",
        base_label: "Βασικές ώρες (11:00 · 14:00 · 17:00)",
        added_label: "Επιπλέον ώρες",
        summary_label: "Διαθέσιμες ώρες αυτή τη μέρα",
        status_open: "Ανοιχτή",
        status_booked: "Κλεισμένη",
        status_blocked: "Μπλοκαρισμένη",
        block: "Μπλοκάρισμα",
        unblock: "Ξεμπλοκάρισμα",
        add: "Προσθήκη",
        remove: "Αφαίρεση",
        no_added: "Δεν έχεις προσθέσει επιπλέον ώρες.",
        no_available: "Καμία διαθέσιμη ώρα.",
        invalid_time: "Μη έγκυρη ώρα (μορφή HH:MM).",
        saved: "Αποθηκεύτηκε",
        save_error: "Αποτυχία αποθήκευσης",
        load_error: "Αποτυχία φόρτωσης",
        close: "Κλείσιμο",
      },
      phone_book: {
        open_button: "Νέο Ραντεβού",
        title: "Νέο Ραντεβού",
        subtitle: "Καταχώρησε νέο ραντεβού — με email ο πελάτης θα λάβει επιβεβαίωση.",
        source_label: "Πηγή ραντεβού",
        source_phone: "Τηλεφωνικά",
        source_other: "Άλλη Πηγή",
        customer_label: "Πελάτης",
        customer_existing: "Υπάρχων Πελάτης",
        customer_new: "Νέος Πελάτης",
        search_ph: "Αναζήτηση με όνομα, τηλέφωνο, email, ράτσα ή όνομα σκύλου...",
        search_empty: "Δεν βρέθηκε πελάτης.",
        change_customer: "Αλλαγή πελάτη",
        locked_hint: "Τα στοιχεία συμπληρώθηκαν αυτόματα από το ιστορικό του πελάτη.",
        tab_grooming: "Grooming",
        tab_selfwash: "Self-Service",
        name: "Όνομα",
        surname: "Επώνυμο (προαιρετικό)",
        phone: "Κινητό (69ΧΧΧΧΧΧΧΧ)",
        email: "Email πελάτη (προαιρετικό)",
        email_error: "Το email πρέπει να είναι έγκυρο.",
        pet_name: "Όνομα κατοικιδίου",
        pet_breed: "Ράτσα",
        pet_size: "Μέγεθος",
        sizes: { small: "Μικρό", medium: "Μεσαίο", large: "Μεγάλο", giant: "Γίγαντας" },
        service: "Υπηρεσία",
        service_placeholder: "π.χ. μπάνιο & κούρεμα",
        plan: "Πλάνο",
        date: "Ημερομηνία",
        time: "Ώρα",
        total: "Σύνολο",
        no_slots: "Καμία διαθέσιμη ώρα",
        save_grooming: "Καταχώρηση Grooming",
        save_selfwash: "Καταχώρηση Self-Service",
        saving: "Καταχώρηση...",
        saved: "Το ραντεβού καταχωρήθηκε!",
        error: "Κάτι πήγε στραβά.",
        required: "Συμπλήρωσε τα υποχρεωτικά πεδία.",
        phone_error: "Το τηλέφωνο πρέπει να είναι 10 ψηφία (69ΧΧΧΧΧΧΧΧ).",
        email_note: "Αν προστεθεί email, ο πελάτης θα λάβει αυτόματα επιβεβαίωση κράτησης.",
      },
    },
    holiday: {
      title: "Καλοκαιρινές Διακοπές",
      subtitle: "Ενημέρωση",
      range_label: "Κλειστά",
      body: "Σας ενημερώνουμε ότι το κατάστημά μας θα παραμείνει κλειστό λόγω καλοκαιρινών διακοπών από τις 9 έως τις 23 Αυγούστου. Θα χαρούμε να σας εξυπηρετήσουμε ξανά από τις 24, με ανανεωμένη διάθεση και την ίδια αφοσίωση στους τετράποδους φίλους μας.",
      thanks: "Ευχαριστούμε για την κατανόηση 🐾",
      dismiss: "Το κατάλαβα",
    },
    cookies: {
      title: "Cookies & αναλυτικά",
      body: "Μόνο με τη συγκατάθεσή σου ενεργοποιούμε εργαλεία ανάλυσης επισκεψιμότητας (Google Analytics, Meta Pixel, PostHog) και τον χάρτη Google Maps. Χωρίς αποδοχή, τίποτα από αυτά δεν φορτώνει.",
      accept: "Αποδοχή",
      reject: "Απόρριψη",
      map_blocked: "Ο χάρτης Google Maps φορτώνει μόνο αφού αποδεχτείς τα cookies.",
      map_accept: "Αποδοχή & εμφάνιση χάρτη",
      footer_link: "Cookies",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      nagayu: "Nagayu",
      selfwash: "Self Service",
      grooming: "Grooming",
      gallery: "The Space",
      contact: "Contact",
      book: "Book Now",
      my_bookings: "My Bookings",
      boutique: "Boutique",
      my_account: "My Account",
    },
    hero: {
      badge: "Self-Wash Lounge & Pet Spa Boutique",
      title_1: "The care your best",
      title_2: "friend deserves",
      subtitle:
        "In Keratsini we created a beautiful, welcoming space dedicated to the hygiene, comfort and wellbeing of pets. Professional grooming, self-service bathing and the exclusive Nagayu CO₂ treatment.",
      cta_primary: "Book Now",
      cta_secondary: "Discover Nagayu",
      stat_1: "Certified products",
      stat_2: "Professional equipment",
      stat_3: "A pet-friendly space",
    },
    about: {
      tag: "About us",
      title: "A space built with love",
      p1: "At Care For Me we believe caring for a pet should be a pleasant experience. That's why we created a space where you can easily and quickly groom your dog yourself, using professional facilities.",
      p2: "Every detail is designed so that bath time is comfortable for both pets and their owners — in a safe, clean and warm environment.",
      why_title: "Why Self Service?",
      why_text:
        "Self-service washing gives you the chance to spend time with your pet and strengthen your bond. Many animals feel calmer when cared for by their own person.",
      features: [
        { t: "Special tubs", d: "Designed at the right height for comfort." },
        { t: "Professional showers", d: "Steady pressure & temperature." },
        { t: "Certified products", d: "Safe for every coat type." },
        { t: "Powerful dryers", d: "Fast & gentle drying." },
      ],
    },
    services: {
      tag: "Our services",
      title: "Three ways to pamper your pet",
      grooming_title: "Professional Grooming",
      grooming_desc:
        "Full care by us: bath, haircut, nails, ears and styling. Fill in the form and book your appointment online instantly — your booking is confirmed automatically.",
      grooming_cta: "Request appointment",
      selfwash_title: "Self-Service Wash",
      selfwash_desc:
        "Wash your dog yourself with professional equipment. Pick a plan based on size and book online.",
      selfwash_cta: "See plans",
      nagayu_title: "Nagayu CO₂ Spa",
      nagayu_desc:
        "Our exclusive Japanese carbon-dioxide hydrotherapy. Deep cleansing, skin relief and a silky, healthy coat.",
      nagayu_cta: "Learn more",
    },
    nagayu: {
      tag: "Signature Treatment",
      title: "Nagayu CO₂ Spa",
      subtitle:
        "The game-changing Japanese hydrotherapy. A CO₂ capsule is placed in the bathtub shower head, creating carbonated water full of beneficial properties.",
      how_title: "How it works",
      how_text:
        "After shampooing, we place a CO₂ tablet in the special shower head. It dissolves instantly, creating a ~3-minute carbonated rinse that deep-cleans in ways plain water simply cannot.",
      benefits: [
        { t: "Deep pore cleansing", d: "Removes dirt & waste that cause odor." },
        { t: "Skin relief", d: "Soothes itching, dermatitis & irritation." },
        { t: "Silky coat", d: "A fuller, shinier & healthier coat." },
        { t: "Better circulation", d: "CO₂ boosts blood flow & cell regeneration." },
        { t: "Lasting freshness", d: "Your pet stays fresh-smelling for longer." },
        { t: "100% natural", d: "Non-invasive, safe & cruelty-free." },
      ],
      note: "Nagayu relieves symptoms but does not replace veterinary care.",
      cta: "Book with Nagayu",
    },
    gallery: {
      tag: "Our space",
      title: "A glimpse of our space",
      subtitle: "Take a look at our space and some of the furry friends we've pampered with love.",
      show_more: "More photos",
      show_less: "Fewer photos",
    },
    hours: {
      title: "Opening Hours",
      closed: "Closed",
      days: [
        { d: "Monday", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Tuesday", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Wednesday", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Thursday", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Friday", h: "12:00–14:30 · 17:30–20:30" },
        { d: "Saturday", h: "11:00–15:00" },
        { d: "Sunday", h: "Closed", closed: true },
      ],
    },
    lg: {
      back: "Home page",
      badge: "Professional Grooming",
      hero_h1: "Professional Dog Grooming",
      hero_p: "Treat your dog to complete care from experienced hands. Professional grooming keeps the coat healthy, the skin clean and your pet comfortable — ideal for every breed and age.",
      cta_book: "Book an Appointment",
      cta_request: "Request Appointment",
      includes_h2: "What Grooming Includes",
      includes: ["Bath", "Drying", "Haircut", "De-matting", "Nail care", "Ear cleaning", "Nagayu CO₂ Spa (+€10)", "Care advice"],
      why_h2: "Why choose Care For Me",
      why: ["Experienced staff", "Safe handling", "Quality products", "Clean & hygienic space", "Personalized care"],
      space_h2: "Our Space",
      space_p: "A beautiful, welcoming and clean space designed for your pet's comfort and safety.",
      contact_h2: "Come and meet us",
    },
    ls: {
      back: "Home page",
      badge: "Self-Service Wash",
      hero_h1: "Self Wash – Wash your dog yourself, easily & cleanly",
      hero_p: "Forget the mess and stress of bathing at home. At Care For Me you'll find professional tubs, warm water and all the products to wash your dog quickly, easily and affordably.",
      cta_book: "Book an Appointment",
      cta_request: "Request Appointment",
      how_h2: "How Self Wash works",
      how_steps: [
        { t: "1. Book online", d: "Pick a plan based on your dog's size and a time that suits you." },
        { t: "2. Come to the space", d: "We welcome you and show you the wash station and equipment." },
        { t: "3. Wash comfortably", d: "Use our special tubs, showers and products with ease." },
        { t: "4. Dry & go", d: "Dry your dog with our professional dryers — we clean up the station." },
      ],
      find_h2: "What you'll find here",
      find: ["Special tubs at the right height", "Professional warm/cold showers", "Certified shampoos & products", "Powerful professional dryers", "Towels & full equipment", "Nagayu CO₂ Spa (+€10)"],
      why_h2: "Why choose Care For Me",
      why: ["Clean & hygienic space", "Professional equipment", "Easy & fast process", "Affordable solution", "No mess at home"],
      space_h2: "Our Space",
      space_p: "A clean, bright and welcoming space, designed to make washing easy and pleasant for you and your dog.",
      contact_h2: "Come and meet us",
    },
    selfwash: {
      tag: "Self-Service Plans",
      type_label: "Self-Service Booking",
      title: "Choose your plan",
      subtitle: "Prices based on your dog's size. All include full access to our equipment.",
      badge_instant: "Instant confirmation",
      badge_secure: "Secure online booking",
      minutes: "minutes",
      book: "Book online",
      includes: "Includes tub, shower, products & dryer",
      plans: [
        { name: "Small Dog", min: 16, price: 10 },
        { name: "Medium Dog", min: 22, price: 14 },
        { name: "Large Dog", min: 32, price: 20 },
        { name: "Giant", min: 40, price: 24 },
      ],
      popular: "Popular",
      choose: "Choose & Book",
      booking: {
        title: "Self-Service Booking",
        step_plan: "Plan",
        step_datetime: "Date & Time",
        step_details: "Details",
        selected_plan: "Selected plan",
        pick_date: "Pick a date",
        pick_time: "Available times",
        no_slots: "No available times. Please pick another day.",
        call_soon: "For an appointment within the next 2 hours, call us:",
        coupon_label: "Coupon code (optional)",
        coupon_check: "Apply",
        coupon_applied: "Discount applied: {label}",
        coupon_fill_phone: "Fill in your phone first",
        loading: "Loading...",
        name: "First name",
        surname: "Surname (optional)",
        phone: "Mobile phone",
        phone_hint: "10 digits, format 69XXXXXXXX",
        phone_error: "Phone must be 10 digits starting with 69",
        email: "Email",
      email_error: "Please provide a valid email",
        notes: "Notes (optional)",
        payment_note: "Payment is made at the store.",
        back: "Back",
        next: "Continue",
        confirm: "Confirm booking",
        confirming: "Confirming...",
        success: "Your booking is confirmed! See you soon.",
        error: "Something went wrong. Please try again.",
        slot_taken: "This slot was just booked. Please pick another.",
        required: "Please fill in name & phone.",
        summary: "Summary",
        addon_title: "Add Nagayu CO₂ Spa",
        addon_desc: "Japanese CO₂ hydrotherapy for deep cleansing & a shiny coat.",
        addon_price: "+€10",
        total: "Total",
      },
    },
    grooming: {
      tag: "Grooming Booking",
      title: "Book your appointment online",
      subtitle: "Pick a date & time and confirm your booking in a few minutes — instant confirmation.",
      badge_instant: "Instant confirmation",
      badge_secure: "Secure online booking",
      customer_name: "First name",
      surname: "Surname (optional)",
      phone: "Mobile phone",
      phone_hint: "10 digits, format 69XXXXXXXX",
      phone_error: "Phone must be 10 digits starting with 69",
      email: "Email",
      email_error: "Please provide a valid email",
      pet_name: "Pet name",
      pet_breed: "Breed",
      pet_size: "Size",
      service_wanted: "What would you like for your dog?",
      service_wanted_placeholder: "e.g. bath & dry, scissor haircut, nails, ear cleaning, Nagayu spa...",
      date: "Date",
      time: "Time",
      notes: "Additional notes (optional)",
      pick_date: "Pick a date",
      pick_time: "Pick a time",
      pick_size: "Pick size",
      closed_day: "Closed on this day",
      loading: "Loading...",
      time_taken: "booked",
      call_more_slots: "For more available times, please call us:",
      call_soon: "For an appointment within the next 2 hours, call us:",
      coupon_label: "Coupon code (optional)",
      coupon_check: "Apply",
      coupon_applied: "Discount applied: {label}",
      coupon_fill_phone: "Fill in your phone first",
      sizes: { small: "Small", medium: "Medium", large: "Large", giant: "Giant" },
      submit: "Confirm booking",
      submitting: "Confirming...",
      success: "Your booking is confirmed! See you soon.",
      error: "Something went wrong. Please try again.",
      required: "Please fill in the required fields.",
    },
    my_bookings: {
      title: "My Bookings",
      subtitle: "View, edit or cancel your bookings online",
      phone_label: "Mobile phone",
      phone_hint: "10 digits, format 69XXXXXXXX",
      phone_error: "Phone must be 10 digits starting with 69",
      search: "Find my bookings",
      searching: "Searching...",
      change_phone: "Change phone",
      no_bookings: "No active bookings found for this number.",
      lookup_error: "Something went wrong. Please try again.",
      grooming: "Grooming",
      selfwash: "Self-Service",
      status: "Status",
      edit: "Edit",
      cancel: "Cancel",
      confirm_cancel: "Are you sure you want to cancel this booking?",
      cancelled: "Booking cancelled.",
      cancel_error: "Cancellation failed.",
      edit_title: "Edit Booking",
      date: "Date",
      time: "Time",
      notes: "Notes",
      back: "Back",
      save: "Save",
      saving: "Saving...",
      saved: "Changes saved.",
      save_error: "Save failed.",
      slot_taken: "This slot is already booked. Please pick another.",
      invalid_time: "Time not available.",
      loading: "Loading...",
      no_slots: "No available slots.",
      privacy_note: "Only active bookings are shown. For past history, please call us.",
    },
    contact: {
      tag: "Contact",
      title: "Come and meet us",
      address_label: "Address",
      address: "Smolensky 1, Keratsini, 18756",
      get_directions: "Get directions",
      phone_label: "Phones",
      email_label: "Email",
      hours_label: "Hours",
      hours: "Mon–Sat: 09:00–21:00",
      form_title: "Send us a message",
      first_name: "First name",
      last_name: "Last name",
      email: "Email",
      message: "Message",
      send: "Send",
      sending: "Sending...",
      success: "Thank you! We'll contact you soon.",
      error: "Something went wrong. Please try again.",
      follow: "Find us on Social",
    },
    footer: {
      tagline: "Self-Wash Lounge & Pet Spa Boutique in Keratsini.",
      quick: "Quick links",
      contact: "Contact",
      rights: "All rights reserved.",
      admin: "Admin",
    },
    seo: {
      home_title: "Care For Me | Pet Spa & Self-Service Dog Wash — Keratsini",
      home_desc: "Professional grooming, self-service dog wash, Nagayu CO₂ therapy and a care boutique in Keratsini. Book your appointment online.",
      grooming_title: "Dog grooming in Keratsini | Care For Me",
      grooming_desc: "Professional grooming: bath, haircut and styling by an experienced groomer. See the packages and book online.",
      self_title: "Self-service dog wash | Care For Me Keratsini",
      self_desc: "Wash your dog in a modern self-service space with professional equipment and Nagayu CO₂ therapy. Book a slot online.",
      shop_title: "Pet care boutique | Care For Me",
      shop_desc: "Care and wellbeing products for pets. Order online and pick up from our store in Keratsini.",
      cart_title: "Cart | Care For Me Boutique",
      checkout_title: "Checkout | Care For Me Boutique",
      account_title: "My account | Care For Me",
    },
    reviews: {
      tag: "Reviews",
      title: "What our customers say",
      sub: "Real stories from our everyday work",
      google_cta: "Review us on Google",
    },
    share: {
      button: "Share",
      title: "Share this product",
      whatsapp: "WhatsApp",
      viber: "Viber",
      facebook: "Facebook",
      instagram: "Instagram / Story",
      copy: "Copy link",
      copied: "Link copied",
    },
    mapp: {
      splash_tag: "Store management",
      code_title: "Enter your access code",
      code_sub: "Your personal access code",
      code_wrong: "Wrong code — try again",
      login_btn: "Sign in",
      welcome: "Welcome",
      pin_setup_title: "Quick sign-in with a PIN",
      pin_setup_sub: "Set a 4-digit PIN so you don't type your code every time",
      pin_choose: "Choose a PIN (4 digits)",
      pin_confirm: "Confirm your PIN",
      pin_mismatch: "PINs don't match — try again",
      pin_skip: "Not now",
      pin_title: "Enter PIN",
      pin_wrong: "Wrong PIN",
      pin_forgot: "Forgot PIN — sign in with code",
      deactivated_title: "Account deactivated",
      deactivated_msg: "Your account is temporarily deactivated.",
      deactivated_contact: "Contact the administrator:",
      deactivated_back: "Back to sign-in",
      pin_lockdown: "2 wrong PINs — the account was automatically deactivated for security reasons",
      bio_offer_title: "Unlock with fingerprint / face?",
      bio_offer_sub: "Use your device's biometrics for instant sign-in",
      bio_enable: "Enable",
      bio_later: "Later",
      bio_unlock: "Unlock with biometrics",
      tab_today: "Today",
      tab_new: "New",
      tab_customers: "Customers",
      tab_orders: "Orders",
      tab_messages: "Messages",
      tab_settings: "Settings",
      tab_dev: "Management",
      dev_hub_sub: "Every Dev capability, inside the app",
      sec_overview: "Overview",
      sec_grooming: "Grooming bookings",
      sec_selfwash: "Self-Service",
      sec_boutique: "Boutique",
      sec_reviews: "Reviews",
      sec_gallery: "Gallery",
      sec_appusers: "App users",
      sec_sms: "SMS",
      sec_templates: "Templates",
      sec_announcement: "Announcement",
      sec_popup: "Site popup",
      sec_themes: "Themes",
      sec_settings: "Settings",
      sec_system: "System",
      stat_today: "Today",
      stat_pending: "Pending",
      stat_orders: "New orders",
      stat_msgs: "Unread",
      stat_revenue: "Boutique revenue",
      dev_save: "Save",
      dev_saved: "Saved",
      dev_delete: "Delete",
      dev_del_confirm: "Delete permanently?",
      dev_empty: "Nothing here yet",
      dev_active: "Active",
      dev_upload: "Upload image",
      dev_uploading: "Uploading…",
      dev_price: "Price €",
      dev_sale: "Sale €",
      dev_splash: "Splash screen",
      dev_balance: "SMS balance",
      dev_test_sms: "Test SMS (phone)",
      dev_test_send: "Send",
      dev_hours: "Opening hours",
      dev_closed: "Closed",
      dev_plan_prices: "Self-service plan prices",
      dev_health_ok: "All systems go",
      dev_health_issue: "Needs attention",
      dev_open_app: "Open",
      pe_new: "New product",
      pe_edit: "Edit product",
      pe_basics: "Basics",
      pe_name_gr: "Name (GR)",
      pe_name_en: "Name (EN)",
      pe_desc: "Description (GR)",
      pe_price: "Price €",
      pe_category: "Category",
      pe_brand: "Partner / brand",
      pe_active: "Active in boutique",
      pe_orderable: "Online ordering",
      pe_axes: "Variant axes",
      pe_sizes: "Sizes (comma-separated)",
      pe_colors: "Colours",
      pe_custom_axis: "Custom axis (name GR)",
      pe_custom_opts: "Custom options (comma-separated)",
      pe_variants: "Variants",
      pe_add_variant: "New variant",
      pe_stock: "Stock",
      pe_avail: "Availability",
      pe_price_opt: "Price (empty = base)",
      pe_sale_opt: "Sale €",
      pe_photos: "Photos",
      pe_add_photos: "Add photos",
      pe_save_first: "Save the product first to add photos",
      pe_delete_confirm: "Permanently delete this product?",
      avail_in: "In stock",
      avail_order: "On order",
      avail_out: "Unavailable",
      comma_hint: "e.g. S, M, L",
      today_empty: "No bookings",
      upcoming: "Upcoming",
      today_label: "Today",
      mark_done: "Complete",
      mark_cancel: "Cancel",
      cancel_confirm: "Cancel this booking for sure?",
      status_done_toast: "Booking completed",
      status_cancelled_toast: "Booking cancelled",
      w_choose_type: "What are we booking?",
      w_grooming: "Grooming",
      w_grooming_sub: "Bath, haircut, styling",
      w_selfwash: "Self-Service",
      w_selfwash_sub: "The customer washes their own dog",
      w_customer: "Which customer?",
      w_existing: "Existing",
      w_new: "New customer",
      w_search_ph: "Name, phone or pet…",
      w_no_results: "Not found — continue as new",
      w_name: "Full name",
      w_phone: "Mobile (69…)",
      w_email: "Email (optional)",
      w_pet_step: "Pet details",
      w_pet_name: "Pet name",
      w_pet_breed: "Breed",
      w_pet_size: "Size",
      w_plan_step: "Choose a plan",
      w_nagayu: "Add Nagayu CO₂ (+€10)",
      w_date_step: "Which day?",
      w_time_step: "What time?",
      w_any_time: "Any time you want — no availability restriction",
      w_no_slots: "No available times this day",
      w_notes: "Notes (optional)",
      w_confirm: "Confirm",
      w_confirm_btn: "Book appointment",
      w_back: "Back",
      w_next: "Next",
      w_success: "Appointment booked!",
      w_success_sub: "Sorting hat says: yes!",
      w_view_today: "See the schedule",
      size_small: "Small",
      size_medium: "Medium",
      size_large: "Large",
      size_giant: "Giant",
      cust_search_title: "Customer search",
      cust_bookings: "Bookings",
      cust_revenue: "Revenue",
      cust_last: "Last visit",
      cust_history: "History",
      cust_notes: "Notes",
      cust_note_ph: "New note…",
      cust_note_add: "Add",
      cust_empty: "Type at least 2 characters",
      orders_empty: "No orders yet",
      messages_empty: "No messages",
      msg_unread: "New",
      settings_title: "App settings",
      set_user: "Signed in as",
      set_change_pin: "Change PIN",
      set_current_pin: "Current PIN",
      set_new_pin: "New PIN",
      set_pin_changed: "PIN changed",
      set_pin_wrong_current: "Wrong current PIN",
      set_notif: "Notifications",
      set_notif_sub: "New bookings & orders on this device",
      set_notif_enable: "Enable notifications",
      set_notif_on: "Active on this device",
      set_notif_test: "Send test notification",
      set_notif_no_perm: "You don't have the notifications permission — ask the administrator",
      set_notif_denied: "The browser blocked notifications — enable them in device settings",
      set_bio: "Biometrics",
      set_web: "Full web panel",
      set_dev_panel: "Management panel (Dev)",
      set_dev_panel_sub: "Full access — every Dev option",
      set_logout: "Sign out",
      loading: "Loading…",
      error_generic: "Something went wrong — try again",
      no_access: "You have no access to this section",
      install_title: "Install the app",
      install_sub: "For security reasons, the management app only opens as an installed app from your home screen.",
      install_detected: "Detected",
      install_now: "Install",
      install_or_steps: "or follow the steps",
      install_steps_title: "Follow the steps",
      install_chrome_1: "Tap the ⋮ menu at the top right",
      install_chrome_2: "Choose “Add to Home screen” or “Install app”",
      install_chrome_3: "Tap “Install”",
      install_samsung_1: "Tap the ☰ menu at the bottom right",
      install_samsung_2: "Choose “Add page to”",
      install_samsung_3: "Choose “Home screen”",
      install_firefox_1: "Tap the ⋮ menu",
      install_firefox_2: "Choose “Install” or “Add to Home screen”",
      install_edge_1: "Tap the ☰ menu at the bottom center",
      install_edge_2: "Choose “Add to phone”",
      install_safari_1: "Tap the Share button at the bottom of the screen",
      install_safari_2: "Scroll down and choose “Add to Home Screen”",
      install_safari_3: "Tap “Add” at the top right",
      install_other_1: "Tap the install icon in your browser's address bar",
      install_other_2: "Then open the app from its icon",
      install_ios_other_title: "On iPhone you need Safari",
      install_ios_other_text: "Apple only allows installing apps via Safari. Copy the link and open it in Safari.",
      install_copy_link: "Copy link",
      install_copied: "Link copied — open it in Safari",
      install_after_title: "After installing",
      install_after_text: "Open the app from the “Care For Me” icon on your home screen — not from the browser.",
      consent_title: "Publication consent",
      consent_msg: "Do you allow Care For Me to publish photos or videos of your pet on the business website and social media?",
      consent_hint: "The customer answers themselves — the booking completes normally with either choice",
      consent_yes: "YES, I AGREE",
      consent_no: "NO, I DON'T AGREE",
      consent_saved: "Consent saved",
      consent_label: "Photo/video consent",
      consent_status_granted: "Consent given",
      consent_status_declined: "Consent not given",
      consent_status_none: "No consent recorded",
      consent_status_revoked: "Consent revoked",
      consent_set_yes: "Agrees",
      consent_set_no: "Declines",
      consent_set_revoke: "Revoke",
      consent_history: "Consent history",
    },
    a11y: {
      title: "Accessibility",
      subtitle: "Customize your experience",
      text_size: "Text size",
      normal: "Normal",
      large: "Large",
      xl: "Extra large",
      contrast: "High contrast",
      links: "Highlight links",
      motion: "Reduce motion",
      reset: "Reset",
      open: "Open accessibility menu",
    },
    shop: {
      title: "Care For Me Boutique",
      subtitle: "Hand-picked products for your four-legged friend — pickup & payment at the shop.",
      search_ph: "Search products...",
      hub_brands: "Partners",
      hub_categories: "Categories",
      hub_all: "All products",
      hub_all_hint: "Browse the whole boutique catalogue",
      hub_back: "Back to overview",
      all_categories: "All categories",
      all_brands: "All partners",
      sort_newest: "Newest",
      sort_price_asc: "Price: low to high",
      sort_price_desc: "Price: high to low",
      sort_name: "Alphabetical",
      avail_in_stock: "In stock now",
      avail_on_order: "Available to order",
      avail_unavailable: "Unavailable",
      sale_badge: "Sale",
      add_to_cart: "Add to cart",
      added: "Added to cart!",
      details: "Details",
      empty: "No products found.",
      vat_note: "Prices include VAT.",
      select_variant: "Choose an option",
      select_size: "Size",
      select_color: "Colour",
      legend_hint: "Key: green = in stock · amber = on order · grey = sold out",
      stock_left: "Stock:",
      max_stock: "Up to available stock",
      cart_title: "My cart",
      cart_empty: "Your cart is empty.",
      qty: "Quantity",
      remove: "Remove",
      subtotal: "Subtotal",
      discount: "Discount",
      total: "Total",
      checkout_btn: "Checkout",
      continue_shopping: "Continue shopping",
      checkout_title: "Checkout",
      mode_login: "Sign in",
      mode_register: "New account",
      mode_guest: "Continue as guest",
      contact_details: "Your details",
      notes: "Notes (optional)",
      place_order: "Place order",
      placing: "Placing...",
      summary: "Order summary",
      coupon_ph: "Coupon code",
      coupon_apply: "Apply",
      coupon_invalid: "Invalid coupon",
      pickup_note: "Pickup & payment at the shop — cash or card at the register. No shipping.",
      call_to_order: "To order this product, give us a call or drop by the shop.",
      confirm_title: "Your order has been placed!",
      confirm_body: "We will notify you by email and SMS as soon as it is ready for pickup. It stays reserved for 5 business days from then.",
      order_number: "Order number",
      back_shop: "Back to the Boutique",
      lookup_title: "Find your order",
      lookup_btn: "Search",
      coming_soon_title: "The Boutique is coming soon!",
      coming_soon_body: "We are preparing a small, carefully selected range of products for your four-legged friends. Stay tuned!",
      unlock_ph: "Access password",
      unlock_btn: "Enter",
      unlock_error: "Wrong password.",
      wishlist_add: "Add to favourites",
      wishlist_remove: "Remove from favourites",
      wishlist_login: "Sign in to save favourites",
      home_eyebrow: "Drag to explore",
      home_title: "From our Boutique",
      home_sub: "A small, carefully selected range for your four-legged friend — pickup from the shop.",
      home_view_all: "View the Boutique",
    },
    account: {
      title: "My Account",
      subtitle: "Bookings, orders and details — all in one place.",
      login: "Sign in",
      register: "Register",
      first_name: "First name",
      last_name: "Last name (optional)",
      email: "Email",
      phone: "Mobile phone",
      phone_hint: "10 digits, 69XXXXXXXX format",
      password: "Password",
      login_btn: "Sign in",
      logging_in: "Signing in...",
      register_btn: "Create account",
      registering: "Creating...",
      forgot_link: "Forgot my password",
      forgot_title: "Password reset",
      forgot_body: "Enter your email and we will send you a reset link.",
      forgot_btn: "Send link",
      forgot_sent: "If an account exists with this email, a reset link is on its way.",
      guest_lookup: "Find a booking without an account",
      welcome: "Hello",
      logout: "Sign out",
      tab_home: "Home",
      tab_bookings: "My bookings",
      tab_orders: "My orders",
      tab_profile: "My details",
      tab_pets: "My pets",
      tab_wishlist: "Favourites",
      next_booking: "Next booking",
      no_upcoming: "No upcoming booking.",
      new_booking_btn: "Book now",
      last_order: "Latest order",
      no_orders: "No orders yet.",
      go_shop: "Visit the Boutique",
      upcoming: "Upcoming",
      past: "Past",
      manage_bookings: "Manage bookings (edit/cancel)",
      bookings_empty: "No bookings found for this account.",
      autolink_note: "Bookings and orders with the same email or phone are automatically linked to your account.",
      order_status: {
        new: "New",
        preparing: "Being prepared",
        awaiting_supplier: "Awaiting supplier",
        ready: "Ready for pickup",
        completed: "Completed",
        cancelled: "Cancelled",
        extended: "Deadline extended",
        supply_to_order: "To be ordered",
        supply_ordered: "Ordered from supplier",
        supply_received: "Received",
      },
      ready_until: "Pickup by",
      history: "History",
      save: "Save",
      saving: "Saving...",
      saved: "Details saved.",
      change_password: "Change password",
      current_password: "Current password",
      new_password: "New password",
      password_changed: "Password changed.",
      delete_account: "Delete account",
      delete_body: "Your account will be permanently deleted. Your bookings and orders remain with the shop.",
      delete_password_ph: "Enter your password to confirm",
      delete_confirm_btn: "Delete permanently",
      deleted: "Account deleted.",
      pets_empty: "No pets found — they appear automatically from your bookings.",
      wishlist_empty: "No favourite products yet.",
      orders_empty: "No orders yet.",
      visits: "visits",
      reset_title: "New password",
      reset_btn: "Save new password",
      reset_done: "Password changed! Sign in with your new password.",
      reset_invalid: "The link has expired or is invalid.",
      items: "items",
    },
    ashop: {
      nav_boutique: "Boutique",
      tab_overview: "Overview",
      tab_products: "Products",
      tab_categories: "Categories",
      tab_suppliers: "Suppliers",
      tab_orders: "Orders",
      tab_stats: "Statistics",
      tab_settings: "Settings",
      new_orders: "New orders",
      ready_orders: "Ready for pickup",
      supplier_pending: "Awaiting supplier",
      total_products: "Products",
      add_product: "New product",
      edit_product: "Edit product",
      name_gr: "Name (GR)",
      name_en: "Name (EN)",
      description_gr: "Description (GR)",
      description_en: "Description (EN)",
      price: "Price (€, incl. VAT)",
      brand: "Partner",
      category: "Category",
      supplier: "Supplier",
      none: "—",
      variants: "Options (size/colour/edition)",
      add_variant: "Add option",
      variant_label: "Label (e.g. Medium / Red)",
      variant_price_ph: "€ (empty = base)",
      variant_sale_ph: "sale € (empty = none)",
      stock: "Stock",
      availability: "Availability",
      eta: "Business days until ready",
      images: "Photos",
      img_all: "All variants",
      upload_image: "Upload photo",
      active: "Active",
      online_orderable: "Allow online ordering when 'available to order'",
      online_orderable_hint: "If off, the customer is asked to call or visit the shop.",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      delete_confirm: "Are you sure you want to delete?",
      saved_toast: "Saved.",
      deleted_toast: "Deleted.",
      groomer_hint: "You can view products and change availability only.",
      order: "Order",
      customer: "Customer",
      items: "Items",
      total: "Total",
      status: "Status",
      date: "Date",
      actions: "Actions",
      statuses: {
        new: "New",
        preparing: "Being prepared",
        awaiting_supplier: "Awaiting supplier",
        ready: "Ready for pickup",
        completed: "Completed",
        cancelled: "Cancelled",
        extended: "Deadline extended",
        supply_to_order: "To be ordered",
        supply_ordered: "Ordered",
        supply_received: "Received",
      },
      history: "Change history",
      ready_deadline: "Pickup deadline",
      extend_btn: "Extend",
      extend_days: "days",
      extended_toast: "Deadline extended.",
      status_toast: "Status updated.",
      ready_blocked: "Not all products have been received.",
      supplier_orders_title: "Supplier orders",
      supplier_orders_hint: "Products customers ordered that are not in stock, grouped by supplier.",
      no_supplier_items: "Nothing pending — all good!",
      stage_to_order: "To order",
      stage_ordered: "Ordered",
      stage_received: "Received",
      mark_ordered: "Mark as ordered",
      mark_received: "Mark as received",
      qty_short: "×",
      for_order: "for order",
      add_category: "New category",
      add_supplier: "New supplier",
      contact: "Contact",
      notes: "Notes",
      empty_products: "No products yet. Add the first one!",
      empty_orders: "No orders yet.",
      empty_categories: "No categories.",
      stats_total: "Total orders",
      stats_revenue: "Revenue (completed)",
      stats_ready_value: "Value ready for pickup",
      stats_top: "Top products",
      settings_title: "Boutique settings",
      eshop_enabled: "Boutique enabled (public)",
      eshop_hidden: "Remove from the site menu",
      access_password: "Preview password (for entry while closed)",
      access_password_set: "A password is set",
      access_password_ph: "New password (empty = keep current)",
      settings_saved: "Settings saved.",
      coupon_badge: "Coupon",
      home_section: "Boutique section on the homepage",
      featured_title: "Homepage products (up to 8)",
      featured_hint: "Tap products in the order you want them to appear.",
      featured_none: "None selected — the section stays hidden on the homepage.",
      tab_colors: "Colours",
      colors_title: "Colour library",
      colors_hint: "Reusable colours you can pick on any product. The photo shows next to the colour choice.",
      color_name_gr: "Colour name (GR)",
      color_name_en: "Colour name (EN)",
      add_color: "New colour",
      empty_colors: "No colours yet.",
      color_photo: "Colour photo",
      sizes_label: "Available sizes",
      sizes_hint: "Type a size and press Enter (e.g. S, M, L)",
      sizes_ph: "e.g. Medium",
      colors_label: "Available colours",
      colors_empty_hint: "Add colours in the «Colours» tab first.",
      custom_axis_label: "Third option (optional)",
      custom_axis_name_gr: "Option title (GR) — e.g. Material",
      custom_axis_name_en: "Option title (EN)",
      custom_axis_options: "Options",
      custom_axis_ph: "Type an option and press Enter (e.g. Leather)",
      combos_generate: "Generate combinations",
      combos_replace_hint: "Existing size/colour combinations will be replaced.",
      combo_size: "Size",
      combo_color: "Colour",
      manual_options: "Simple options (no size/colour)",
      search_products: "Search products...",
      search_no_results: "No product found.",
      price_inline: "Variant price (empty = base price)",
      sale_inline: "Offer price (empty = none)",
      colors_badge: "«X Colours» badge on the product image",
      drag_hint: "Drag to change display order",
      cat_photo: "Category photo",
      brands_photos_title: "Partner photos",
      brands_photos_hint: "Suppliers appear here automatically and can get a photo. The public page only shows partners with products.",
    },
    themes: {
      nav: "THEMES",
      title: "Seasonal themes",
      hint: "Activate a theme and the whole public site dresses up for the season — colours, decorations and animations. One theme at a time.",
      activate: "Activate",
      deactivate: "Deactivate",
      on_toast: "Theme activated!",
      off_toast: "Theme deactivated",
      splash_label: "Festive splash screen",
      splash_hint: "On page entry (with the Christmas theme): logo, days until Christmas / New Year and a loading bar for 4 seconds.",
      splash_on: "Splash screen enabled",
      splash_off: "Splash screen disabled",
      splash_xmas: "Days until Christmas",
      splash_newyear: "Days until New Year",
      splash_loading: "Loading the page...",
      names: { christmas: "Christmas", halloween: "Halloween", apokries: "Carnival", easter: "Easter", summer: "Summer" },
      desc: {
        christmas: "Snowfall, twinkling lights and warm festive colours",
        halloween: "Pumpkins, bats, cobwebs and floating ghosts",
        apokries: "Confetti, streamers and carnival masks",
        easter: "Easter eggs, flowers and flying butterflies",
        summer: "Waves, sunshine and a holiday feel on the buttons",
      },
    },
    popup: {
      title: "Site popup",
      subtitle: "A popup message visitors see once per visit.",
      enabled: "Popup enabled",
      icon: "Icon",
      ptitle: "Title",
      text: "Text",
      btn: "Button",
      btn_none: "No button",
      btn_section: "Goes to a page section",
      btn_url: "External link",
      btn_label: "Button label",
      section: "Page section",
      url: "Link (https://...)",
      save: "Save popup",
      saved: "Popup saved.",
      preview: "Preview",
      sections: {
        about: "About",
        services: "Services",
        nagayu: "Nagayu",
        selfwash: "Self Service",
        grooming: "Grooming booking",
        gallery: "The Space",
        contact: "Contact",
        shop: "Boutique",
      },
    },
    admin: {
      login_title: "Admin Login",
      login_sub: "Care For Me — Management panel",
      email: "Email or Username",
      password: "Password",
      login: "Sign in",
      logging: "Signing in...",
      logout: "Logout",
      dashboard: "Dashboard",
      bookings: "Grooming Requests",
      selfwash: "Self-Service",
      messages: "Messages",
      total_bookings: "Total bookings",
      pending: "Pending",
      total_messages: "Total messages",
      unread: "Unread",
      total_selfwash: "Self-Service bookings",
      selfwash_today: "Today",
      revenue: "Self-Service revenue",
      no_bookings: "No requests yet.",
      no_messages: "No messages yet.",
      no_selfwash: "No bookings yet.",
      search: "Search...",
      all: "All",
      status: "Status",
      actions: "Actions",
      login_error: "Invalid credentials.",
      refresh: "Refresh",
      landing_pages: "Landing Pages",
      landing_grooming: "Landing Grooming",
      landing_self: "Landing Self",
      new_booking_title: "New Booking!",
      new_booking_body: "You have new bookings waiting.",
      accept: "Accept",
      sound_on: "Sound: On",
      sound_off: "Sound: Off",
      completed: "Completed",
      no_completed: "No completed items yet.",
      email_sent_badge: "Email sent",
      email_not_sent_badge: "Send now",
      email_none: "No email",
      email_send_title: "Send confirmation email to customer",
      email_sent_toast: "Email sent to customer",
      email_send_error: "Failed to send email",
      reminder_sent_badge: "Reminder sent",
      reminder_at: "Reminder",
      reminder_not_scheduled: "not scheduled",
      reminder_send_now: "Send now",
      reminder_send_title: "Send the reminder now",
      reminder_edit_title: "Change reminder time",
      reminder_manual_label: "Reminder",
      reminder_manual_title: "Send SMS reminder now (outside the scheduled one)",
      reminder_manual_confirm: "Send the customer an SMS reminder? ({n}/2 manual)",
      reminder_manual_sent: "Reminder sent",
      review_prompt_title: "Send review SMS?",
      review_prompt_body: "The appointment is done. Send the customer a thank-you SMS with the Google review link?",
      review_prompt_send: "Yes, send",
      review_prompt_skip: "No",
      review_sent_toast: "Review SMS sent",
      discount_applied: "Discount",
      winback_title: "Missing customers",
      winback_sub: "Haven't visited in over a month and have no upcoming booking",
      winback_empty: "Nobody is missing right now — everyone visited recently!",
      winback_count: "{n} customers away for over a month",
      winback_days_away: "{n} days ago",
      winback_last: "Last: {d}",
      winback_send: "Send",
      winback_message: "Message",
      winback_history: "Previous sends",
      winback_confirm: "Send to {n} customer(s) via {channel}?",
      winback_sent: "Sent: {s} · Failed: {f}",
      winback_low_credits: "Contact the site administrator to send the message (low SMS balance)",
      winback_personalized: "Each customer will receive the message with their own name",
      winback_preview_for: "Preview for: {name}",
      winback_locked: "Locked template — editing is done by the administrator",
      coupon_add: "Add discount coupon",
      coupon_kind: "Type",
      coupon_percent: "Percent %",
      coupon_euro: "Euro €",
      coupon_amount: "Amount",
      coupon_expires: "Expires",
      coupon_service: "Service",
      coupon_selfwash: "Self-Service",
      coupon_grooming: "Grooming",
      coupon_both: "Both",
      coupon_note: "Unique code per customer, single use, bound to their phone.",
      reminder_confirm_send: "Send the reminder now?",
      reminder_sent_toast: "Reminder sent",
      reminder_schedule_saved: "Reminder schedule saved",
      reminder_dialog: {
        title: "Schedule reminder",
        subtitle: "Pick the send date and time",
        date_label: "Date",
        time_label: "Time",
        hour: "Hour",
        minute: "Minutes",
      },
      sms: {
        title: "SMS Reminders",
        subtitle: "Automatic SMS: booking confirmation, changes and 24h reminder",
        on: "On",
        off: "Off",
        toggled_on: "SMS reminders enabled",
        toggled_off: "SMS reminders disabled",
        test_send: "Send test SMS",
        test_sending: "Sending...",
        test_placeholder: "69XXXXXXXX",
        test_success: "Test SMS sent!",
        last_attempt: "Last attempt",
        never: "none yet",
        badge_pending: "SMS",
        badge_sent: "SMS sent",
        badge_failed: "SMS failed",
        resend: "Resend",
        resent_toast: "SMS sent again",
        send_error: "SMS send failed",
        toggle_error: "Failed to change setting",
        history_button: "SMS History",
        balance: "Balance",
        history_title: "SMS History",
        history_subtitle: "All SMS that have been sent",
        history_empty: "No SMS sent yet.",
        history_refresh: "Refresh",
        success: "Success",
        failed: "Failed",
        kinds: { test: "Test", confirmation: "Confirmation", edit: "Change", reminder: "Reminder" },
      },
      email_history: {
        button: "Email History",
        title: "Email History",
        subtitle: "All emails that have been sent",
        empty: "No emails sent yet.",
        view_content: "Content",
        kinds: { admin: "Shop notification", confirmation: "Confirmation", edit: "Change", cancel: "Cancellation", reminder: "Reminder", bulk: "Bulk" },
      },
      month_cal: { weekdays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"] },
      today_agenda: "Today's appointments",
      no_today: "No appointments today",
      ack_button: "Got it!",
      day_bookings: "Day bookings",
      role_groomer: "Shop",
      role_dev: "Dev",
      tab_analytics: "Analytics",
      tab_customers: "Customers",
      tab_gallery: "Gallery",
      tab_messaging: "SMS & Email",
      tab_settings: "Settings",
      tab_all: "All",
      dev: {
        visits: "Visits",
        bookings_14d: "Bookings (14 days)",
        messages_14d: "Messages (14 days)",
        vs_prev: "vs previous 14 days",
        per_page: "Views per page",
        weekly_revenue: "Self-Service revenue per week",
        month_compare: "Monthly comparison",
        bookings: "Bookings",
        revenue: "Self-Service revenue",
        this_month: "This month",
        last_month: "Last month",
        customers_title: "Customers",
        customers_sub: "Unique customers across all bookings",
        col_customer: "Customer",
        col_bookings: "Bookings",
        col_revenue: "Revenue",
        col_last: "Last booking",
        bulk_title: "Bulk message to customers",
        bulk_message: "Message",
        bulk_channel_sms: "SMS",
        bulk_channel_email: "Email",
        bulk_recipients: "recipients",
        bulk_est_cost: "Estimated cost",
        bulk_credits: "credits",
        bulk_send: "Send",
        bulk_sending: "Sending...",
        bulk_confirm_sms: "Send SMS to {n} customers (~{c} credits)?",
        bulk_confirm_email: "Send email to {n} customers?",
        bulk_done: "Done: {s}/{t} succeeded",
        bulk_sms_off: "The SMS toggle is OFF — turn it on first",
        gallery_title: "Gallery management",
        gallery_sub: "Upload, delete or reorder the site photos",
        gallery_upload: "Upload photo",
        gallery_uploading: "Uploading...",
        gallery_delete_confirm: "Delete this photo?",
        gallery_empty: "No photos.",
        gallery_deleted: "Photo deleted",
        gallery_uploaded: "Photo uploaded",
        health_title: "Possible issues",
        health_all_ok: "Everything looks good",
        closures_title: "Holidays / Closed days",
        closures_from: "From",
        closures_to: "To",
        closures_reason: "Reason (optional)",
        closures_add: "Add",
        closures_save: "Save closures",
        closures_saved: "Closures saved",
        closures_empty: "No closures — the shop follows regular hours",
        closures_popup: "Show popup on the site",
        closures_popup_text: "Popup text (e.g. Closed for holidays)",
        weekly_title: "Weekly grooming slots",
        weekly_sub: "Base available times per day, comma separated",
        weekly_placeholder: "e.g. 11:00, 14:00, 17:00",
        weekly_save: "Save slots",
        weekly_saved: "Weekly slots saved",
        hours_title: "Opening hours",
        hours_sub: "Up to 2 windows per day (e.g. 12:00–14:30 and 17:30–20:30). Empty = closed.",
        hours_save: "Save hours",
        hours_saved: "Opening hours saved",
        day_names: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        nav_overview: "Overview",
        nav_templates: "Templates",
        nav_system: "System",
        dev_badge: "DEV ENVIRONMENT",
        menu_open: "Menu",
        ov_today: "Today",
        ov_pending: "Pending",
        ov_week: "Next 7 days",
        ov_messages: "New messages",
        quick_actions: "Quick actions",
        search_customers: "Search (name, phone, email, pet, breed)...",
        profile_title: "Customer profile",
        profile_history: "Booking history",
        profile_notes: "Customer notes",
        note_placeholder: "New note... (e.g. the dog is scared of the dryer)",
        note_add: "Add",
        note_empty: "No notes yet",
        note_edit: "Edit",
        note_save: "Save",
        last_visit_label: "Last visit",
        select_all: "All",
        select_none: "None",
        selected_recipients: "{n} selected recipients",
        no_recipients: "Select recipients first",
        templates_title: "SMS Templates",
        templates_sub: "The automatic SMS customers receive. Placeholders: {name}, {date}, {time}, {link}. The “Care For Me” signature is appended automatically.",
        tpl_confirmation: "Confirmation SMS",
        tpl_edit: "Booking-change SMS",
        tpl_reminder: "Reminder SMS (24h before)",
        tpl_review: "Review SMS (Google review link)",
        tpl_winback: "Win-back SMS (lapsed customers)",
        tpl_order_confirmation: "Boutique order confirmation SMS — {name} {order}",
        tpl_order_ready: "'Ready for pickup' SMS — {name} {order} {date}",
        accounts_title: "Registered accounts",
        accounts_sub: "Customers with a careforme.gr account — click for details",
        account_badge: "Account",
        account_none: "No account created yet.",
        account_registered: "Registered",
        account_send_reset: "Send password reset email",
        account_reset_sent: "Password reset email sent to the customer.",
        account_delete: "Delete account",
        account_delete_confirm: "Permanently delete this account? Bookings and orders remain.",
        account_deleted: "Account deleted.",
        coupons_title: "Coupons",
        coupon_new: "New coupon",
        coupon_create: "Create",
        coupon_created: "Coupon created",
        coupon_used: "Used",
        coupon_active: "Active",
        coupon_expired: "Expired",
        coupon_everywhere: "Valid everywhere: grooming, self-service and Boutique.",
        coupon_sms_ask: "Send the customer an SMS with the coupon?",
        coupon_sms_sent: "Coupon SMS sent",
        orders_title: "Boutique orders",
        wishlist_label: "favourites",
        cust_add: "New customer",
        cust_add_sub: "Manual entry without a booking — the shop will find them as an existing customer",
        cust_name: "Full name",
        cust_phone_l: "Phone",
        cust_email_l: "Email (optional)",
        cust_pet: "Pet (optional)",
        cust_breed: "Breed",
        cust_size: "Size",
        cust_note_l: "Note (optional)",
        cust_save: "Save customer",
        cust_saved: "Customer added",
        size_small: "Small",
        size_medium: "Medium",
        size_large: "Large",
        size_giant: "Giant",
        past_add: "Past booking",
        past_title: "Add past booking",
        past_sub: "Recorded as completed — no SMS/email is sent to the customer",
        past_type: "Type",
        past_date: "Date",
        past_time: "Time",
        past_service: "Service (optional)",
        past_plan: "Plan",
        past_price: "Price € (optional)",
        past_notes: "Note (optional)",
        past_save: "Save entry",
        past_saved: "Past booking recorded",
        past_badge: "Manual",
        nav_reviews: "Reviews",
        rev_title: "Customer reviews",
        rev_sub: "Visible reviews appear on the homepage",
        rev_add: "New review",
        rev_name: "Name (e.g. Maria K.)",
        rev_text: "Review text",
        rev_rating: "Stars",
        rev_sort: "Order",
        rev_visible: "Visible",
        rev_hidden: "Hidden",
        rev_edit: "Edit",
        rev_save: "Save",
        rev_saved: "Review saved",
        rev_deleted: "Review deleted",
        rev_delete_confirm: "Permanently delete this review?",
        rev_empty: "No reviews yet — add the first one",
        rev_google_url: "\"Review us on Google\" link",
        rev_google_hint: "Empty = automatic Google Maps search for the business",
        rev_google_save: "Save link",
        rev_google_saved: "Link saved",
        nav_app_users: "App users",
        nav_app_mobile: "Mobile app",
        au_title: "Mobile app users",
        au_sub: "Access to “Care For Me Management” with a personal code — separate from website accounts",
        au_add: "New user",
        au_name: "Name (e.g. Anna)",
        au_code: "Access code (4–12 characters)",
        au_code_edit_hint: "Empty = keep the current code",
        au_perms: "Permissions",
        perm_schedule: "Schedule",
        perm_bookings: "Booking management",
        perm_customers: "Customers",
        perm_orders: "Orders",
        perm_messages: "Messages",
        perm_notifications: "Notifications",
        perm_desc_schedule: "Sees the calendar and each day's bookings",
        perm_desc_bookings: "Books new appointments (wizard) and changes status — complete/cancel",
        perm_desc_customers: "Customer search, customer card, history and notes",
        perm_desc_orders: "Sees boutique orders and changes their status",
        perm_desc_messages: "Sees and reads incoming contact messages",
        perm_desc_notifications: "Gets a push notification on their device for new bookings or orders",
        au_active: "Active",
        au_inactive: "Deactivated",
        au_edit: "Edit",
        au_save: "Save",
        au_saved: "User saved",
        au_deleted: "User deleted",
        au_delete_confirm: "Permanently delete this user?",
        au_empty: "No app users yet — create the first one",
        au_badge: "Role",
        badge_store: "Store",
        badge_management: "Management",
        au_badge_hint: "“Management” automatically gets ALL permissions and can open the full Dev panel from the app",
        am_title: "Mobile app",
        am_sub: "Install “Care For Me Management” on staff phones",
        am_link: "App link",
        am_copied: "Link copied",
        am_android_title: "Android",
        am_android_1: "Open the link in the phone's Chrome",
        am_android_2: "Tap the ⋮ menu → “Install app” / “Add to Home screen”",
        am_android_3: "The app appears as a regular icon and supports notifications",
        am_android_apk: "For a signed APK: open pwabuilder.com, paste the link, tap “Package for Android” and download the APK",
        am_ios_title: "iPhone / iPad",
        am_ios_1: "Open the link in Safari",
        am_ios_2: "Tap Share → “Add to Home Screen”",
        am_ios_3: "Notifications work on iOS 16.4 and newer",
        am_note: "Sign-in uses the personal code you set under “App users”.",
        am_push_title: "Send a notification to the phones",
        am_push_t: "Title",
        am_push_msg: "Message",
        am_push_target: "Recipient",
        am_push_all: "Everyone (with notifications permission)",
        am_push_send: "Send notification",
        am_push_sent: "Sent to {n} devices",
        am_push_none: "No devices enrolled — enable notifications from the app (Settings)",
        tpl_save: "Save templates",
        tpl_saved: "Templates saved",
        tpl_reset: "Reset to defaults",
        tpl_reset_done: "Templates reset to defaults",
        tpl_preview: "Preview",
        system_title: "System status",
        system_sms_log: "Recent SMS sends",
        system_no_logs: "No sends yet",
        system_delivery_note: "SMSBox does not provide separate delivery reports — this shows the send result from the account.",
        export_csv: "Export CSV",
        export_done: "File downloaded",
        refresh: "Refresh",
        logout: "Logout",
        closures_single_day: "Single day only",
        closures_date: "Date",
        nav_announcement: "Announcement",
        ann_form_title: "New announcement to the shop",
        ann_form_sub: "It will show as a popup on the shop dashboard until they press “Got it!”.",
        ann_title: "Title",
        ann_body: "Text",
        ann_icon: "Icon",
        ann_attachment: "Attachment (optional)",
        ann_attachment_pick: "Choose file",
        ann_send: "Publish",
        ann_sending: "Publishing...",
        ann_sent: "Announcement published",
        ann_list: "Previous announcements",
        ann_empty: "No announcements yet",
        ann_seen: "Seen by: {n}",
        ann_unseen: "Not seen yet",
        ann_delete_confirm: "Delete this announcement?",
        prices_title: "Self-Service plan prices",
        prices_save: "Save prices",
        prices_saved: "Prices saved",
        password_title: "Change password",
        password_current: "Current password",
        password_new: "New password (min 6)",
        password_save: "Change password",
        password_saved: "Password changed",
        links_title: "Quick links",
        filter_type: "Type",
        filter_status: "Status",
        filter_all: "All",
        grooming_type: "Grooming",
        selfwash_type: "Self-Service",
      },
      edit: "Edit",
      edit_title: "Edit Booking",
      save: "Save",
      saving: "Saving...",
      cancel: "Cancel",
      saved: "Changes saved",
      saved_with_email: "Saved · Customer notified",
      notify_customer_question: "Send an email and SMS to the customer with the changes?",
      save_error: "Save failed",
      grooming_type: "Grooming",
      selfwash_type: "Self-Service",
      statuses: { pending: "Pending", contacted: "Contacted", confirmed: "Confirmed", done: "Done", cancelled: "Cancelled", no_show: "No show" },
      slots: {
        open_button: "Grooming Hours",
        title: "Manage Grooming Hours",
        subtitle: "Add or remove time slots per date",
        date_label: "Date",
        base_label: "Base slots (11:00 · 14:00 · 17:00)",
        added_label: "Extra slots",
        summary_label: "Available slots on this day",
        status_open: "Open",
        status_booked: "Booked",
        status_blocked: "Blocked",
        block: "Block",
        unblock: "Unblock",
        add: "Add",
        remove: "Remove",
        no_added: "No extra slots yet.",
        no_available: "No available slots.",
        invalid_time: "Invalid time (HH:MM format).",
        saved: "Saved",
        save_error: "Save failed",
        load_error: "Load failed",
        close: "Close",
      },
      phone_book: {
        open_button: "New Appointment",
        title: "New Appointment",
        subtitle: "Log a new appointment — with an email, the customer receives a confirmation.",
        source_label: "Appointment source",
        source_phone: "By phone",
        source_other: "Other source",
        customer_label: "Customer",
        customer_existing: "Existing Customer",
        customer_new: "New Customer",
        search_ph: "Search by name, phone, email, breed or dog name...",
        search_empty: "No customer found.",
        change_customer: "Change customer",
        locked_hint: "Details auto-filled from the customer's history.",
        tab_grooming: "Grooming",
        tab_selfwash: "Self-Service",
        name: "First name",
        surname: "Surname (optional)",
        phone: "Mobile (69XXXXXXXX)",
        email: "Customer email (optional)",
        email_error: "Email must be valid.",
        pet_name: "Pet name",
        pet_breed: "Breed",
        pet_size: "Size",
        sizes: { small: "Small", medium: "Medium", large: "Large", giant: "Giant" },
        service: "Service",
        service_placeholder: "e.g. bath & haircut",
        plan: "Plan",
        date: "Date",
        time: "Time",
        total: "Total",
        no_slots: "No available slots",
        save_grooming: "Save Grooming",
        save_selfwash: "Save Self-Service",
        saving: "Saving...",
        saved: "Booking saved!",
        error: "Something went wrong.",
        required: "Please fill required fields.",
        phone_error: "Phone must be 10 digits (69XXXXXXXX).",
        email_note: "If email is provided, the customer will receive an automatic confirmation.",
      },
    },
    holiday: {
      title: "Summer Holidays",
      subtitle: "Announcement",
      range_label: "Closed",
      body: "Please note that our shop will be closed for summer holidays from 9 to 23 August. We will be delighted to welcome you again from the 24th, refreshed and with the same dedication to our four-legged friends.",
      thanks: "Thank you for your understanding 🐾",
      dismiss: "Got it",
    },
    cookies: {
      title: "Cookies & analytics",
      body: "Only with your consent do we enable traffic analytics tools (Google Analytics, Meta Pixel, PostHog) and the Google Maps map. Without acceptance, none of these load.",
      accept: "Accept",
      reject: "Reject",
      map_blocked: "The Google Maps map loads only after you accept cookies.",
      map_accept: "Accept & show map",
      footer_link: "Cookies",
    },
  },
};

export const LUXEBOOK_URL = "https://www.luxebook.gr/w/care-for-me";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_paw-care-hub-15/artifacts/spcefxs6_Logo%20wide%20better.png";
export const FUNDING_BANNER_URL = "https://customer-assets.emergentagent.com/job_paw-care-hub-15/artifacts/ezgk4jl5_scale-up-banner-white.webp";
export const MAPS_DIRECTIONS = "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent("Σμολένσκυ 1, Κερατσίνι 18756");
export const PHONE_1 = "2111102354";
export const PHONE_2 = "6947527558";
export const SHOP_PHOTO_WIDE = "https://customer-assets.emergentagent.com/job_paw-care-hub-15/artifacts/3wmvpsix_DSC_0031.webp";
export const SHOP_PHOTO_TALL = "https://customer-assets.emergentagent.com/job_paw-care-hub-15/artifacts/i3g7hk1f_unnamed.webp";

const A = "https://customer-assets.emergentagent.com/job_paw-care-hub-15/artifacts/";
const B = "https://customer-assets-v7afamib.emergentagent.net/job_paw-care-hub-15/artifacts/";
export const SHOP_GALLERY = [
  // Νεότερα portraits πελατών (2026-09) — εμφανίζονται πρώτα
  B + "ort5j2gg_WhatsApp%20Image%202026-09-22%20at%2010.50.40%20PM.jpeg",
  B + "rq1oco70_WhatsApp%20Image%202026-09-22%20at%2010.56.02%20PM.jpeg",
  B + "7g2w4yoq_WhatsApp%20Image%202026-09-22%20at%2011.04.29%20PM.jpeg",
  B + "4ccbr85m_WhatsApp%20Image%202026-09-22%20at%2011.13.00%20PM.jpeg",
  A + "vmsktsn2_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM.webp",
  A + "r0lees6k_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%281%29.webp",
  A + "4ggxsw8p_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%282%29.webp",
  A + "fs1vf67k_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%283%29.webp",
  A + "0xrd6uwx_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%284%29.webp",
  A + "1asigi66_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%285%29.jpeg",
  A + "dj7mnay6_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%286%29.jpeg",
  A + "h7pyd27n_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%287%29.jpeg",
  A + "lo83i530_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%288%29.jpeg",
  A + "hadkoods_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%289%29.jpeg",
  A + "q8qgvrme_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2810%29.jpeg",
  A + "fj3lp4v3_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2811%29.jpeg",
  A + "ok2ad15s_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2812%29.jpeg",
  A + "9t9ts8bv_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2813%29.jpeg",
  A + "jb2m6229_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2814%29.jpeg",
  A + "v2s5jg8r_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2815%29.jpeg",
  A + "7r42s75j_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2816%29.jpeg",
  A + "r4znutsk_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2817%29.jpeg",
  A + "3zjzxwla_WhatsApp%20Image%202026-07-09%20at%203.10.59%20PM%20%2819%29.jpeg",
];
export const IMG_GROOM = SHOP_GALLERY[0];
export const IMG_WASH = SHOP_PHOTO_WIDE;
export const IMG_NAGAYU = SHOP_GALLERY[16];
